// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/barlow-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/barlow-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/barlow-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/barlow-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/barlow-condensed-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/barlow-condensed-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/barlow-condensed-600.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: "Barlow", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
    --color-amber-50: oklch(98.7% 0.022 95.277);
    --color-amber-300: oklch(87.9% 0.169 91.605);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-green-50: oklch(98.2% 0.018 155.826);
    --color-green-100: oklch(96.2% 0.044 156.743);
    --color-green-200: oklch(92.5% 0.084 155.995);
    --color-green-300: oklch(87.1% 0.15 154.449);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-green-700: oklch(52.7% 0.154 150.069);
    --color-green-800: oklch(44.8% 0.119 151.328);
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-2xl: 42rem;
    --container-5xl: 64rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-5xl: 3rem;
    --text-5xl--line-height: 1;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --tracking-tight: -0.025em;
    --tracking-wide: 0.025em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-relaxed: 1.625;
    --radius-sm: 0.25rem;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-xl: 0.75rem;
    --radius-2xl: 1rem;
    --animate-spin: spin 1s linear infinite;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --font-body: "Barlow", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    --font-display: "Barlow Condensed", "Arial Black", Arial, sans-serif;
    --color-primary-50: var(--color-uni-blue-50);
    --color-primary-100: var(--color-uni-blue-100);
    --color-primary-200: var(--color-uni-blue-200);
    --color-primary-300: var(--color-uni-blue-300);
    --color-primary-400: var(--color-uni-blue-400);
    --color-primary-500: var(--color-uni-blue-500);
    --color-primary-600: var(--color-uni-blue-600);
    --color-primary-700: var(--color-uni-blue-700);
    --color-primary-800: var(--color-uni-blue-800);
    --color-primary-900: var(--color-uni-blue-900);
    --color-primary-950: var(--color-uni-blue-950);
    --color-danger-50: var(--color-uni-red-50);
    --color-danger-100: var(--color-uni-red-100);
    --color-danger-200: var(--color-uni-red-200);
    --color-danger-300: var(--color-uni-red-300);
    --color-danger-400: var(--color-uni-red-400);
    --color-danger-500: var(--color-uni-red-500);
    --color-danger-600: var(--color-uni-red-600);
    --color-danger-700: var(--color-uni-red-700);
    --color-danger-800: var(--color-uni-red-800);
    --color-danger-900: var(--color-uni-red-900);
    --color-danger-950: var(--color-uni-red-950);
    --color-info-50: var(--color-lcsb-sky-50);
    --color-info-100: var(--color-lcsb-sky-100);
    --color-info-200: var(--color-lcsb-sky-200);
    --color-info-300: var(--color-lcsb-sky-300);
    --color-info-400: var(--color-lcsb-sky-400);
    --color-info-500: var(--color-lcsb-sky-500);
    --color-info-600: var(--color-lcsb-sky-600);
    --color-info-700: var(--color-lcsb-sky-700);
    --color-info-800: var(--color-lcsb-sky-800);
    --color-info-900: var(--color-lcsb-sky-900);
    --color-info-950: var(--color-lcsb-sky-950);
    --color-on-primary: #ffffff;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .inset-x-1 {
    inset-inline: calc(var(--spacing) * 1);
  }
  .start {
    inset-inline-start: var(--spacing);
  }
  .end {
    inset-inline-end: var(--spacing);
  }
  .-top-2 {
    top: calc(var(--spacing) * -2);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .top-\\[50\\%\\] {
    top: 50%;
  }
  .right-0 {
    right: calc(var(--spacing) * 0);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .left-\\[50\\%\\] {
    left: 50%;
  }
  .isolate {
    isolation: isolate;
  }
  .\\!z-\\[9999\\] {
    z-index: 9999 !important;
  }
  .z-10 {
    z-index: 10;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .-mx-1 {
    margin-inline: calc(var(--spacing) * -1);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-1 {
    margin-block: calc(var(--spacing) * 1);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .my-8 {
    margin-block: calc(var(--spacing) * 8);
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-auto {
    margin-top: auto;
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-1\\.5 {
    margin-right: calc(var(--spacing) * 1.5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-auto {
    margin-left: auto;
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-\\[var\\(--radix-select-trigger-height\\)\\] {
    height: var(--radix-select-trigger-height);
  }
  .h-px {
    height: 1px;
  }
  .max-h-96 {
    max-height: calc(var(--spacing) * 96);
  }
  .max-h-\\[90vh\\] {
    max-height: 90vh;
  }
  .\\!min-h-\\[40px\\] {
    min-height: 40px !important;
  }
  .min-h-\\[3rem\\] {
    min-height: 3rem;
  }
  .min-h-\\[40vh\\] {
    min-height: 40vh;
  }
  .min-h-\\[80px\\] {
    min-height: 80px;
  }
  .min-h-dvh {
    min-height: 100dvh;
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-auto {
    width: auto;
  }
  .w-full {
    width: 100%;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-5xl {
    max-width: var(--container-5xl);
  }
  .max-w-\\[8rem\\] {
    max-width: 8rem;
  }
  .max-w-\\[14rem\\] {
    max-width: 14rem;
  }
  .max-w-\\[280px\\] {
    max-width: 280px;
  }
  .max-w-lg {
    max-width: var(--container-lg);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-\\[8rem\\] {
    min-width: 8rem;
  }
  .min-w-\\[200px\\] {
    min-width: 200px;
  }
  .min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
    min-width: var(--radix-select-trigger-width);
  }
  .flex-1 {
    flex: 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .translate-x-\\[-50\\%\\] {
    --tw-translate-x: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-y-\\[-50\\%\\] {
    --tw-translate-y: -50%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .\\!cursor-not-allowed {
    cursor: not-allowed !important;
  }
  .\\!cursor-pointer {
    cursor: pointer !important;
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .resize-y {
    resize: vertical;
  }
  .scroll-mt-32 {
    scroll-margin-top: calc(var(--spacing) * 32);
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .\\!gap-1 {
    gap: calc(var(--spacing) * 1) !important;
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .space-y-1\\.5 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-3 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 3) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 3) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-4 {
    column-gap: calc(var(--spacing) * 4);
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .\\!overflow-hidden {
    overflow: hidden !important;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .\\!rounded-lg {
    border-radius: var(--radius-lg) !important;
  }
  .\\!rounded-md {
    border-radius: var(--radius-md) !important;
  }
  .\\!rounded-sm {
    border-radius: var(--radius-sm) !important;
  }
  .\\!rounded-xl {
    border-radius: var(--radius-xl) !important;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-t-2xl {
    border-top-left-radius: var(--radius-2xl);
    border-top-right-radius: var(--radius-2xl);
  }
  .rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .rounded-r-lg {
    border-top-right-radius: var(--radius-lg);
    border-bottom-right-radius: var(--radius-lg);
  }
  .rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .\\!border {
    border-style: var(--tw-border-style) !important;
    border-width: 1px !important;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-l-2 {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-l-4 {
    border-left-style: var(--tw-border-style);
    border-left-width: 4px;
  }
  .\\!border-danger-900 {
    border-color: var(--color-danger-900) !important;
  }
  .\\!border-gray-200 {
    border-color: var(--color-gray-200) !important;
  }
  .\\!border-gray-300 {
    border-color: var(--color-gray-300) !important;
  }
  .\\!border-primary-900 {
    border-color: var(--color-primary-900) !important;
  }
  .border-amber-300 {
    border-color: var(--color-amber-300);
  }
  .border-danger-300 {
    border-color: var(--color-danger-300);
  }
  .border-danger-900 {
    border-color: var(--color-danger-900);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-gray-300 {
    border-color: var(--color-gray-300);
  }
  .border-green-200 {
    border-color: var(--color-green-200);
  }
  .border-green-300 {
    border-color: var(--color-green-300);
  }
  .border-info-300 {
    border-color: var(--color-info-300);
  }
  .border-info-900 {
    border-color: var(--color-info-900);
  }
  .border-primary-900 {
    border-color: var(--color-primary-900);
  }
  .border-transparent {
    border-color: transparent;
  }
  .\\!bg-gray-50 {
    background-color: var(--color-gray-50) !important;
  }
  .\\!bg-gray-200 {
    background-color: var(--color-gray-200) !important;
  }
  .\\!bg-primary-900 {
    background-color: var(--color-primary-900) !important;
  }
  .\\!bg-primary-900\\/10 {
    background-color: var(--color-primary-900) !important;
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary-900) 10%, transparent) !important;
    }
  }
  .\\!bg-white {
    background-color: var(--color-white) !important;
  }
  .bg-amber-50 {
    background-color: var(--color-amber-50);
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-danger-50 {
    background-color: var(--color-danger-50);
  }
  .bg-danger-900 {
    background-color: var(--color-danger-900);
  }
  .bg-gray-100 {
    background-color: var(--color-gray-100);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-green-600 {
    background-color: var(--color-green-600);
  }
  .bg-green-700 {
    background-color: var(--color-green-700);
  }
  .bg-info-50 {
    background-color: var(--color-info-50);
  }
  .bg-primary-50 {
    background-color: var(--color-primary-50);
  }
  .bg-primary-900 {
    background-color: var(--color-primary-900);
  }
  .bg-primary-900\\/8 {
    background-color: var(--color-primary-900);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary-900) 8%, transparent);
    }
  }
  .bg-primary-950 {
    background-color: var(--color-primary-950);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/95 {
    background-color: color-mix(in srgb, #fff 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 95%, transparent);
    }
  }
  .fill-on-primary {
    fill: var(--color-on-primary);
  }
  .fill-primary-900 {
    fill: var(--color-primary-900);
  }
  .\\!p-1 {
    padding: calc(var(--spacing) * 1) !important;
  }
  .p-0 {
    padding: calc(var(--spacing) * 0);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .\\!px-3 {
    padding-inline: calc(var(--spacing) * 3) !important;
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .\\!py-1 {
    padding-block: calc(var(--spacing) * 1) !important;
  }
  .\\!py-2 {
    padding-block: calc(var(--spacing) * 2) !important;
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-5 {
    padding-top: calc(var(--spacing) * 5);
  }
  .pt-6 {
    padding-top: calc(var(--spacing) * 6);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-8 {
    padding-bottom: calc(var(--spacing) * 8);
  }
  .pb-12 {
    padding-bottom: calc(var(--spacing) * 12);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .font-display {
    font-family: var(--font-display);
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .\\!text-sm {
    font-size: var(--text-sm) !important;
    line-height: var(--tw-leading, var(--text-sm--line-height)) !important;
  }
  .\\!text-xs {
    font-size: var(--text-xs) !important;
    line-height: var(--tw-leading, var(--text-xs--line-height)) !important;
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[0\\.8rem\\] {
    font-size: 0.8rem;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-tight {
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .break-all {
    word-break: break-all;
  }
  .whitespace-pre-line {
    white-space: pre-line;
  }
  .\\!text-gray-400 {
    color: var(--color-gray-400) !important;
  }
  .\\!text-gray-500 {
    color: var(--color-gray-500) !important;
  }
  .\\!text-gray-900 {
    color: var(--color-gray-900) !important;
  }
  .\\!text-on-primary {
    color: var(--color-on-primary) !important;
  }
  .\\!text-primary-900 {
    color: var(--color-primary-900) !important;
  }
  .text-amber-900 {
    color: var(--color-amber-900);
  }
  .text-current {
    color: currentcolor;
  }
  .text-danger-900 {
    color: var(--color-danger-900);
  }
  .text-gray-300 {
    color: var(--color-gray-300);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-500\\/50 {
    color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-gray-500) 50%, transparent);
    }
  }
  .text-gray-500\\/60 {
    color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-gray-500) 60%, transparent);
    }
  }
  .text-gray-500\\/80 {
    color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-gray-500) 80%, transparent);
    }
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-green-800 {
    color: var(--color-green-800);
  }
  .text-on-primary {
    color: var(--color-on-primary);
  }
  .text-primary-900 {
    color: var(--color-primary-900);
  }
  .text-primary-900\\/60 {
    color: var(--color-primary-900);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-primary-900) 60%, transparent);
    }
  }
  .text-primary-900\\/70 {
    color: var(--color-primary-900);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-primary-900) 70%, transparent);
    }
  }
  .text-white {
    color: var(--color-white);
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .\\!opacity-50 {
    opacity: 50% !important;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-75 {
    opacity: 75%;
  }
  .\\!shadow-dropdown {
    --tw-shadow: 0 4px 20px var(--tw-shadow-color, rgba(30, 52, 70, 0.15)) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .\\!shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .shadow-dropdown {
    --tw-shadow: 0 4px 20px var(--tw-shadow-color, rgba(30, 52, 70, 0.15));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-overlay {
    --tw-shadow: 0 12px 40px var(--tw-shadow-color, rgba(30, 52, 70, 0.22));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .\\!ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor) !important;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
  }
  .ring-0 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .\\!ring-primary-900 {
    --tw-ring-color: var(--color-primary-900) !important;
  }
  .ring-primary-900 {
    --tw-ring-color: var(--color-primary-900);
  }
  .ring-offset-white {
    --tw-ring-offset-color: var(--color-white);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .backdrop-blur {
    --tw-backdrop-blur: blur(8px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .\\!transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to !important;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function)) !important;
    transition-duration: var(--tw-duration, var(--default-transition-duration)) !important;
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-500 {
    --tw-duration: 500ms;
    transition-duration: 500ms;
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .placeholder\\:text-gray-400 {
    &::placeholder {
      color: var(--color-gray-400);
    }
  }
  .hover\\:border-primary-900 {
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-900);
      }
    }
  }
  .hover\\:\\!bg-primary-900 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-900) !important;
      }
    }
  }
  .hover\\:bg-danger-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-danger-800);
      }
    }
  }
  .hover\\:bg-danger-900 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-danger-900);
      }
    }
  }
  .hover\\:bg-gray-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-100);
      }
    }
  }
  .hover\\:bg-green-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-green-100);
      }
    }
  }
  .hover\\:bg-green-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-green-800);
      }
    }
  }
  .hover\\:bg-primary-800 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-800);
      }
    }
  }
  .hover\\:bg-primary-900 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-900);
      }
    }
  }
  .hover\\:bg-primary-900\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-900);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-primary-900) 10%, transparent);
        }
      }
    }
  }
  .hover\\:\\!text-gray-600 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-600) !important;
      }
    }
  }
  .hover\\:\\!text-on-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary) !important;
      }
    }
  }
  .hover\\:text-on-primary {
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary);
      }
    }
  }
  .hover\\:text-primary-900 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-900);
      }
    }
  }
  .hover\\:text-white {
    &:hover {
      @media (hover: hover) {
        color: var(--color-white);
      }
    }
  }
  .hover\\:opacity-70 {
    &:hover {
      @media (hover: hover) {
        opacity: 70%;
      }
    }
  }
  .hover\\:opacity-80 {
    &:hover {
      @media (hover: hover) {
        opacity: 80%;
      }
    }
  }
  .hover\\:opacity-100 {
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .focus\\:border-danger-900 {
    &:focus {
      border-color: var(--color-danger-900);
    }
  }
  .focus\\:border-primary-900 {
    &:focus {
      border-color: var(--color-primary-900);
    }
  }
  .focus\\:bg-gray-50 {
    &:focus {
      background-color: var(--color-gray-50);
    }
  }
  .focus\\:bg-info-100 {
    &:focus {
      background-color: var(--color-info-100);
    }
  }
  .focus\\:bg-primary-900\\/10 {
    &:focus {
      background-color: var(--color-primary-900);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-primary-900) 10%, transparent);
      }
    }
  }
  .focus\\:text-primary-900 {
    &:focus {
      color: var(--color-primary-900);
    }
  }
  .focus\\:ring-1 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-danger-900 {
    &:focus {
      --tw-ring-color: var(--color-danger-900);
    }
  }
  .focus\\:ring-primary-900 {
    &:focus {
      --tw-ring-color: var(--color-primary-900);
    }
  }
  .focus\\:ring-offset-2 {
    &:focus {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .focus-visible\\:ring-2 {
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus-visible\\:ring-danger-900 {
    &:focus-visible {
      --tw-ring-color: var(--color-danger-900);
    }
  }
  .focus-visible\\:ring-primary-900 {
    &:focus-visible {
      --tw-ring-color: var(--color-primary-900);
    }
  }
  .focus-visible\\:ring-primary-900\\/40 {
    &:focus-visible {
      --tw-ring-color: var(--color-primary-900);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-primary-900) 40%, transparent);
      }
    }
  }
  .focus-visible\\:ring-offset-2 {
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .focus-visible\\:outline-none {
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .disabled\\:pointer-events-none {
    &:disabled {
      pointer-events: none;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:bg-gray-50 {
    &:disabled {
      background-color: var(--color-gray-50);
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
  .data-\\[disabled\\]\\:pointer-events-none {
    &[data-disabled] {
      pointer-events: none;
    }
  }
  .data-\\[disabled\\]\\:opacity-50 {
    &[data-disabled] {
      opacity: 50%;
    }
  }
  .data-\\[side\\=bottom\\]\\:translate-y-1 {
    &[data-side="bottom"] {
      --tw-translate-y: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=left\\]\\:-translate-x-1 {
    &[data-side="left"] {
      --tw-translate-x: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=right\\]\\:translate-x-1 {
    &[data-side="right"] {
      --tw-translate-x: calc(var(--spacing) * 1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[side\\=top\\]\\:-translate-y-1 {
    &[data-side="top"] {
      --tw-translate-y: calc(var(--spacing) * -1);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=checked\\]\\:translate-x-4 {
    &[data-state="checked"] {
      --tw-translate-x: calc(var(--spacing) * 4);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=checked\\]\\:border-primary-900 {
    &[data-state="checked"] {
      border-color: var(--color-primary-900);
    }
  }
  .data-\\[state\\=checked\\]\\:bg-primary-900 {
    &[data-state="checked"] {
      background-color: var(--color-primary-900);
    }
  }
  .data-\\[state\\=checked\\]\\:text-on-primary {
    &[data-state="checked"] {
      color: var(--color-on-primary);
    }
  }
  .data-\\[state\\=unchecked\\]\\:translate-x-0 {
    &[data-state="unchecked"] {
      --tw-translate-x: calc(var(--spacing) * 0);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
  }
  .data-\\[state\\=unchecked\\]\\:bg-gray-200 {
    &[data-state="unchecked"] {
      background-color: var(--color-gray-200);
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:justify-end {
    @media (width >= 40rem) {
      justify-content: flex-end;
    }
  }
  .\\[\\&\\>button\\]\\:pointer-events-none {
    &>button {
      pointer-events: none;
    }
  }
  .\\[\\&\\>button\\]\\:bg-primary-900 {
    &>button {
      background-color: var(--color-primary-900);
    }
  }
  .\\[\\&\\>button\\]\\:bg-primary-900\\/10 {
    &>button {
      background-color: var(--color-primary-900);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-primary-900) 10%, transparent);
      }
    }
  }
  .\\[\\&\\>button\\]\\:font-semibold {
    &>button {
      --tw-font-weight: var(--font-weight-semibold);
      font-weight: var(--font-weight-semibold);
    }
  }
  .\\[\\&\\>button\\]\\:text-gray-400 {
    &>button {
      color: var(--color-gray-400);
    }
  }
  .\\[\\&\\>button\\]\\:text-on-primary {
    &>button {
      color: var(--color-on-primary);
    }
  }
  .\\[\\&\\>button\\]\\:text-primary-900 {
    &>button {
      color: var(--color-primary-900);
    }
  }
  .\\[\\&\\>button\\]\\:opacity-50 {
    &>button {
      opacity: 50%;
    }
  }
  .\\[\\&\\>button\\]\\:hover\\:bg-primary-800 {
    &>button {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-primary-800);
        }
      }
    }
  }
  .\\[\\&\\>button\\]\\:hover\\:text-on-primary {
    &>button {
      &:hover {
        @media (hover: hover) {
          color: var(--color-on-primary);
        }
      }
    }
  }
  .\\[\\&\\>span\\]\\:line-clamp-1 {
    &>span {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
}
/*!
 * @elixir-lu/ui — design tokens
 * Tailwind CSS v4 source. Two tiers:
 *   1. Palette tier  — raw UNI/LCSB brand values as plain custom properties.
 *                      NEVER reference these directly in app templates.
 *   2. Semantic tier — \`@theme\` block; this is what Tailwind generates
 *                      utilities from (bg-primary-900, text-danger-900, …).
 *                      Apps override the semantic→palette mapping in their own
 *                      CSS entry (e.g. DAISY remaps primary → LCSB).
 *
 * Consumption: this file must be processed by Tailwind, and the Tailwind
 * framework must be loaded FIRST in the same compilation (the consumer's CSS /
 * tailwindcss style block must begin with the tailwindcss import). With the
 * browser build (no build step) inline this file's contents into a
 * \`\\3c style type="text/tailwindcss">\` block, after that import. See README.
 * @font-face lives in \`fonts.css\` (plain CSS — load via <link>).
 */
:root {
  --color-uni-blue-50: #e9ebed;
  --color-uni-blue-100: #d2d6da;
  --color-uni-blue-200: #bcc2c8;
  --color-uni-blue-300: #a5aeb5;
  --color-uni-blue-400: #8f9aa3;
  --color-uni-blue-500: #788590;
  --color-uni-blue-600: #62717e;
  --color-uni-blue-700: #4b5d6b;
  --color-uni-blue-800: #354859;
  --color-uni-blue-900: #1e3446;
  --color-uni-blue-950: #142f3f;
  --color-uni-red-50: #fcecea;
  --color-uni-red-100: #f9d8d5;
  --color-uni-red-200: #f6c5c0;
  --color-uni-red-300: #f3b1ab;
  --color-uni-red-400: #f09e97;
  --color-uni-red-500: #ed8a82;
  --color-uni-red-600: #ea776d;
  --color-uni-red-700: #e76358;
  --color-uni-red-800: #e45043;
  --color-uni-red-900: #e13c2e;
  --color-uni-red-950: #e13c2e;
  --color-lcsb-sky-50: #e7f5fc;
  --color-lcsb-sky-100: #e7f5fc;
  --color-lcsb-sky-200: #e7f5fc;
  --color-lcsb-sky-300: #d7effb;
  --color-lcsb-sky-400: #d7effb;
  --color-lcsb-sky-500: #c7e8f9;
  --color-lcsb-sky-600: #c7e8f9;
  --color-lcsb-sky-700: #c7e8f9;
  --color-lcsb-sky-800: #afdef6;
  --color-lcsb-sky-900: #afdef6;
  --color-lcsb-sky-950: #afdef6;
}
/*!
 * @elixir-lu/ui — component classes
 * Tailwind CSS v4 \`@layer components\`. Uses ONLY semantic tokens/utilities
 * (primary / danger / info / on-primary + neutral gray), so an app can
 * restyle everything by remapping the semantic tier in tokens.css.
 *
 * Must be processed by Tailwind (it uses @apply, which needs the Tailwind
 * framework + tokens loaded first in the same compilation). Load the same way
 * as tokens.css, and always AFTER it. See README.
 *
 * Each class mirrors an existing data-catalog markup cluster (see
 * design-system-audit.md §6) 1:1, so adopting them is a visual no-op.
 */
@layer components {
  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    border-radius: var(--radius-lg);
    background-color: var(--color-primary-900);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-on-primary);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-800);
      }
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus-visible {
      --tw-ring-color: var(--color-primary-900);
    }
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .btn-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-primary-900);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary);
      }
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus-visible {
      --tw-ring-color: var(--color-primary-900);
    }
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .btn-danger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-danger-900);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-danger-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-danger-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary);
      }
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus-visible {
      --tw-ring-color: var(--color-danger-900);
    }
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
  }
  .btn-step {
    display: inline-flex;
    align-items: center;
    gap: calc(var(--spacing) * 1);
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-300);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 1.5);
    font-family: var(--font-display);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: 0.15em;
    letter-spacing: 0.15em;
    color: var(--color-primary-900);
    text-transform: uppercase;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary);
      }
    }
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 2px;
    }
    &:focus-visible {
      outline-offset: 2px;
    }
    &:focus-visible {
      outline-color: var(--color-primary-900);
    }
  }
  .btn-step:disabled, .btn-step[aria-disabled="true"] {
    cursor: not-allowed;
    border-color: var(--color-gray-200);
    color: var(--color-gray-400);
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-gray-200);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-white);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-gray-400);
      }
    }
  }
  .btn-page {
    display: inline-flex;
    height: calc(var(--spacing) * 8);
    min-width: calc(var(--spacing) * 8);
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-300);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 2);
    font-family: var(--font-display);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-900);
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary);
      }
    }
  }
  .btn-page-current {
    display: inline-flex;
    height: calc(var(--spacing) * 8);
    min-width: calc(var(--spacing) * 8);
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-primary-900);
    background-color: var(--color-primary-900);
    padding-inline: calc(var(--spacing) * 2);
    font-family: var(--font-display);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-on-primary);
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .btn-icon {
    display: inline-flex;
    height: calc(var(--spacing) * 8);
    width: calc(var(--spacing) * 8);
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    color: var(--color-primary-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .btn-icon-danger {
    display: inline-flex;
    height: calc(var(--spacing) * 8);
    width: calc(var(--spacing) * 8);
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-danger-200);
    background-color: var(--color-white);
    color: var(--color-danger-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-danger-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-danger-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-on-primary);
      }
    }
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 1px;
    }
    &:focus-visible {
      outline-style: var(--tw-outline-style);
      outline-width: 2px;
    }
    &:focus-visible {
      outline-offset: 2px;
    }
    &:focus-visible {
      outline-color: var(--color-danger-900);
    }
    &:disabled {
      cursor: not-allowed;
    }
    &:disabled {
      border-color: var(--color-gray-200);
    }
    &:disabled {
      color: var(--color-gray-400);
    }
    &:disabled {
      &:hover {
        @media (hover: hover) {
          background-color: var(--color-white);
        }
      }
    }
    &:disabled {
      &:hover {
        @media (hover: hover) {
          color: var(--color-gray-400);
        }
      }
    }
  }
  .form-label {
    margin-bottom: calc(var(--spacing) * 1);
    display: block;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-primary-900);
  }
  .form-label a {
    text-decoration-line: underline;
    text-underline-offset: 2px;
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-800);
      }
    }
  }
  .form-required {
    margin-left: calc(var(--spacing) * 0.5);
    color: var(--color-danger-900);
  }
  .form-input {
    display: block;
    width: 100%;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-300);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    color: var(--color-primary-900);
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    &:focus {
      border-color: var(--color-primary-900);
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-primary-900);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .form-input-error {
    border-color: var(--color-danger-900);
    &:focus {
      border-color: var(--color-danger-900);
    }
    &:focus {
      --tw-ring-color: var(--color-danger-900);
    }
  }
  .form-textarea {
    display: block;
    width: 100%;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-300);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    color: var(--color-primary-900);
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    &:focus {
      border-color: var(--color-primary-900);
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-primary-900);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .form-file {
    display: block;
    width: 100%;
    cursor: pointer;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-300);
    background-color: var(--color-white);
    padding: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--color-gray-700);
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    &::file-selector-button {
      margin-right: calc(var(--spacing) * 4);
    }
    &::file-selector-button {
      cursor: pointer;
    }
    &::file-selector-button {
      border-style: var(--tw-border-style);
      border-width: 1px;
    }
    &::file-selector-button {
      border-color: var(--color-primary-900);
    }
    &::file-selector-button {
      background-color: var(--color-white);
    }
    &::file-selector-button {
      padding-inline: calc(var(--spacing) * 4);
    }
    &::file-selector-button {
      padding-block: calc(var(--spacing) * 2);
    }
    &::file-selector-button {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    &::file-selector-button {
      --tw-font-weight: var(--font-weight-semibold);
      font-weight: var(--font-weight-semibold);
    }
    &::file-selector-button {
      color: var(--color-primary-900);
    }
    &::file-selector-button {
      transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
      transition-duration: var(--tw-duration, var(--default-transition-duration));
    }
    &:hover {
      @media (hover: hover) {
        &::file-selector-button {
          background-color: var(--color-primary-900);
        }
      }
    }
    &:hover {
      @media (hover: hover) {
        &::file-selector-button {
          color: var(--color-on-primary);
        }
      }
    }
    &:focus {
      border-color: var(--color-primary-900);
    }
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus {
      --tw-ring-color: var(--color-primary-900);
    }
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .form-checkbox {
    height: calc(var(--spacing) * 4);
    width: calc(var(--spacing) * 4);
    border-radius: var(--radius-md);
    border-color: var(--color-gray-300);
    color: var(--color-primary-900);
    &:focus {
      --tw-ring-color: var(--color-primary-900);
    }
  }
  .form-help {
    margin-top: calc(var(--spacing) * 1);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
    color: var(--color-gray-500);
  }
  .form-error {
    margin-top: calc(var(--spacing) * 1);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--color-danger-900);
  }
  .alert {
    position: relative;
    margin-bottom: calc(var(--spacing) * 4);
    display: flex;
    align-items: flex-start;
    gap: calc(var(--spacing) * 3);
    border-radius: var(--radius-xl);
    border-style: var(--tw-border-style);
    border-width: 1px;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 3);
    color: var(--color-primary-900);
  }
  .alert-error {
    border-color: var(--color-danger-900);
    background-color: var(--color-danger-50);
  }
  .alert-info {
    border-color: var(--color-primary-900);
    background-color: var(--color-primary-50);
  }
  .alert-close {
    color: var(--color-primary-900);
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-700);
      }
    }
  }
  .badge {
    display: inline-flex;
    align-items: center;
    border-radius: var(--radius-md);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-gray-700);
  }
  .badge-link {
    display: inline-flex;
    align-items: center;
    border-radius: var(--radius-md);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-info-300);
    background-color: var(--color-info-50);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-primary-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-info-100);
      }
    }
  }
  .badge-solid {
    display: inline-flex;
    align-items: center;
    border-radius: var(--radius-md);
    background-color: var(--color-primary-900);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-on-primary);
  }
  .badge-tint {
    display: inline-flex;
    align-items: center;
    border-radius: var(--radius-md);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-info-300);
    background-color: var(--color-info-50);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-primary-900);
  }
  .badge-split {
    margin-right: calc(var(--spacing) * 1);
    margin-bottom: calc(var(--spacing) * 1);
    display: inline-flex;
    overflow: hidden;
    border-radius: var(--radius-md);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .badge-split-key {
    background-color: var(--color-gray-100);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-gray-700);
  }
  .badge-split-value {
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 0.5);
    color: var(--color-primary-900);
  }
  .card {
    border-radius: var(--radius-2xl);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    background-color: var(--color-white);
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .panel {
    scroll-margin-top: calc(var(--spacing) * 8);
    padding-block: calc(var(--spacing) * 5);
    @media (width >= 64rem) {
      padding-block: calc(var(--spacing) * 6);
    }
  }
  .panel-summary {
    display: flex;
    cursor: pointer;
    list-style-type: none;
    align-items: center;
    justify-content: space-between;
    gap: calc(var(--spacing) * 3);
  }
  .panel-summary::-webkit-details-marker {
    display: none;
  }
  .panel-title {
    font-family: var(--font-display);
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
    color: var(--color-primary-900);
    @media (width >= 64rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  .panel-icon {
    height: calc(var(--spacing) * 4);
    width: calc(var(--spacing) * 4);
    color: var(--color-gray-400);
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  details.panel[open] .panel-icon {
    rotate: 180deg;
  }
  .panel-body {
    margin-top: calc(var(--spacing) * 4);
  }
  .data-list {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
    :where(& > :not(:last-child)) {
      border-color: var(--color-gray-100);
    }
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
    border-color: var(--color-gray-200);
  }
  .data-row {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: calc(var(--spacing) * 1);
    padding-block: calc(var(--spacing) * 3);
    @media (width >= 40rem) {
      gap: calc(var(--spacing) * 6);
    }
  }
  @media (min-width: 40rem) {
    .data-row {
      grid-template-columns: 12rem minmax(0, 1fr);
    }
  }
  .data-row dt, .data-row-label {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-gray-500);
  }
  .data-row dd, .data-row-value {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
    color: var(--color-primary-900);
  }
  .field-quote {
    background-color: var(--color-gray-50);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 3);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
    color: var(--color-primary-900);
    @media (width >= 64rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .field-quote a {
    color: var(--color-primary-900);
    text-decoration-line: underline;
    text-underline-offset: 2px;
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-800);
      }
    }
  }
  .empty-state {
    border-radius: var(--radius-md);
    border-style: var(--tw-border-style);
    border-width: 1px;
    --tw-border-style: dashed;
    border-style: dashed;
    border-color: var(--color-gray-300);
    padding-inline: calc(var(--spacing) * 6);
    padding-block: calc(var(--spacing) * 8);
    text-align: center;
  }
  .empty-state-text {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--color-gray-500);
  }
  .data-table {
    min-width: 100%;
    border-collapse: collapse;
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    @media (width >= 64rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .data-table th, .data-table td {
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    vertical-align: top;
    color: var(--color-primary-900);
  }
  .data-table thead th, .data-table .data-table-head {
    background-color: var(--color-gray-50);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .link {
    color: var(--color-primary-900);
    text-decoration-line: underline;
    text-underline-offset: 2px;
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-800);
      }
    }
  }
  .tabs {
    display: inline-flex;
    align-items: center;
    gap: calc(var(--spacing) * 1);
    border-radius: var(--radius-xl);
    background-color: var(--color-gray-100);
    padding: calc(var(--spacing) * 1);
    font-family: var(--font-body);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-gray-600);
  }
  .tab {
    border-radius: var(--radius-lg);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 1.5);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-900);
      }
    }
  }
  .tab-active {
    border-radius: var(--radius-lg);
    background-color: var(--color-white);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 1.5);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-900);
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .tabs-underline {
    display: flex;
    gap: calc(var(--spacing) * 6);
    overflow-x: auto;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-color: var(--color-gray-300);
  }
  .tab-underline {
    margin-bottom: -1px;
    flex-shrink: 0;
    cursor: pointer;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
    border-color: transparent;
    padding-inline: calc(var(--spacing) * 1);
    padding-bottom: calc(var(--spacing) * 3);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-gray-600);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-info-900);
      }
    }
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary-900);
      }
    }
    @media (prefers-reduced-motion: reduce) {
      transition-property: none;
    }
  }
  .tab-underline[aria-selected="true"] {
    border-color: var(--color-primary-900);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-900);
  }
  .facet-heading {
    margin-bottom: calc(var(--spacing) * 4);
    display: flex;
    height: calc(var(--spacing) * 9);
    align-items: flex-end;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-color: var(--color-gray-200);
    padding-bottom: calc(var(--spacing) * 2);
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    --tw-leading: 1;
    line-height: 1;
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-gray-600);
  }
  .facet-list {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 0.5) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 0.5) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .facet {
    margin-inline: calc(var(--spacing) * -2);
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 2);
    border-radius: var(--radius-md);
    padding-inline: calc(var(--spacing) * 2);
    padding-block: calc(var(--spacing) * 1.5);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--color-primary-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-50);
      }
    }
  }
  .facet-selected {
    background-color: var(--color-info-50);
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-info-100);
      }
    }
  }
  .facet-check {
    display: flex;
    height: calc(var(--spacing) * 4);
    width: calc(var(--spacing) * 4);
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-md);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    background-color: var(--color-white);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .facet:hover .facet-check {
    border-color: var(--color-primary-900);
  }
  .facet-selected .facet-check {
    border-color: var(--color-primary-900);
    background-color: var(--color-primary-900);
  }
  .facet-label {
    min-width: calc(var(--spacing) * 0);
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .facet-count {
    flex-shrink: 0;
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-gray-600);
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .page-eyebrow {
    font-family: var(--font-display);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-900);
  }
  .page-title {
    font-family: var(--font-display);
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    --tw-tracking: var(--tracking-tight);
    letter-spacing: var(--tracking-tight);
    color: var(--color-primary-900);
    @media (width >= 64rem) {
      font-size: var(--text-5xl);
      line-height: var(--tw-leading, var(--text-5xl--line-height));
    }
  }
  .page-lead {
    max-width: 65ch;
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
    color: var(--color-primary-900);
    @media (width >= 64rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .navbar {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
    border-color: var(--color-gray-200);
    background-color: var(--color-white);
  }
  .nav-link {
    display: block;
    border-radius: var(--radius-lg);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-primary-900);
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-gray-100);
      }
    }
  }
  .nav-link-active {
    display: block;
    border-radius: var(--radius-lg);
    padding-inline: calc(var(--spacing) * 3);
    padding-block: calc(var(--spacing) * 2);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-primary-900);
    text-decoration-line: underline;
    text-decoration-color: var(--color-primary-900);
    text-decoration-thickness: 2px;
    text-underline-offset: 8px;
  }
  .footer-bar {
    background-color: var(--color-primary-950);
    color: color-mix(in srgb, #fff 85%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 85%, transparent);
    }
  }
  .partner-logo {
    display: flex;
    height: calc(var(--spacing) * 20);
    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-xl);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 3);
    opacity: 80%;
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-gray-300);
      }
    }
    &:hover {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
}
:root {
  --duration-stagger: 40ms;
  --duration-micro: 80ms;
  --duration-quick: 150ms;
  --duration-fast: 250ms;
  --duration-medium: 350ms;
  --duration-slow: 400ms;
  --duration-very-slow: 500ms;
  --ease-smooth-out: cubic-bezier(0.22, 1, 0.36, 1);
  --ease-in-out: ease-in-out;
  --ease-out: ease-out;
  --ease-linear: linear;
  --ease-bounce: cubic-bezier(0.34, 1.36, 0.64, 1);
  --ease-bounce-strong: cubic-bezier(0.34, 3.85, 0.64, 1);
  --distance-micro: 4px;
  --distance-small: 6px;
  --distance-base: 8px;
  --distance-medium: 12px;
  --distance-large: 30px;
  --scale-large: 0.96;
  --scale-medium: 0.97;
  --scale-small: 0.98;
  --scale-tiny: 0.99;
  --blur-small: 2px;
  --blur-medium: 3px;
  --blur-large: 8px;
  --resize-dur: 300ms;
  --resize-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --digit-dur: 500ms;
  --digit-distance: 8px;
  --digit-stagger: 70ms;
  --digit-blur: 2px;
  --digit-ease: cubic-bezier(0.34, 1.45, 0.64, 1);
  --digit-dir-x: 0;
  --digit-dir-y: 1;
  --badge-slide-dur: 260ms;
  --badge-pop-dur: 500ms;
  --badge-pop-close-dur: 180ms;
  --badge-fade-dur: 400ms;
  --badge-fade-close-dur: 180ms;
  --badge-blur: 2px;
  --badge-offset-x: -8.2px;
  --badge-offset-y: 12.4px;
  --badge-slide-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --badge-pop-ease: cubic-bezier(0.34, 1.36, 0.64, 1);
  --badge-close-ease: cubic-bezier(0.4, 0, 0.2, 1);
  --text-swap-dur: 150ms;
  --text-swap-translate-y: 4px;
  --text-swap-blur: 2px;
  --text-swap-ease: ease-in-out;
  --dropdown-open-dur: 250ms;
  --dropdown-close-dur: 150ms;
  --dropdown-pre-scale: 0.97;
  --dropdown-closing-scale: 0.99;
  --dropdown-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --modal-open-dur: 250ms;
  --modal-close-dur: 150ms;
  --modal-scale: 0.96;
  --modal-scale-close: 0.96;
  --modal-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --panel-open-dur: 400ms;
  --panel-close-dur: 350ms;
  --panel-translate-y: 100px;
  --panel-blur: 2px;
  --panel-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --page-slide-dur: 250ms;
  --page-fade-dur: 250ms;
  --page-slide-distance: 8px;
  --page-blur: 3px;
  --page-stagger: 0ms;
  --page-exit-enabled: 1;
  --page-slide-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --page-fade-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --icon-swap-dur: 250ms;
  --icon-swap-blur: 2px;
  --icon-swap-start-scale: 0.25;
  --icon-swap-ease: ease-in-out;
  --check-opacity-dur: 500ms;
  --check-rotate-dur: 500ms;
  --check-rotate-from: 80deg;
  --check-bob-dur: 500ms;
  --check-y-amount: 40px;
  --check-blur-dur: 500ms;
  --check-blur-from: 10px;
  --check-path-dur: 500ms;
  --check-path-delay: 80ms;
  --check-ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --check-ease-opacity: cubic-bezier(0.22, 1, 0.36, 1);
  --check-ease-rotate: cubic-bezier(0.22, 1, 0.36, 1);
  --check-ease-bob: cubic-bezier(0.34, 1.35, 0.64, 1);
  --check-ease-path: cubic-bezier(0.22, 1, 0.36, 1);
  --avatar-lift: -4px;
  --avatar-dur: 320ms;
  --avatar-scale: 1.05;
  --avatar-falloff: 0.45;
  --avatar-ease-in: cubic-bezier(0.22, 1, 0.36, 1);
  --avatar-ease-out: cubic-bezier(0.34, 3.85, 0.64, 1);
  --shake-distance: 6px;
  --shake-overshoot: 4px;
  --shake-dur-a: 80ms;
  --shake-dur-b: 60ms;
  --shake-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --revert-hold: 3000ms;
  --revert-dur: 280ms;
  --clear-dur: 1000ms;
  --clear-out-dur: 400ms;
  --clear-in-dur: 400ms;
  --clear-out-fly: 12px;
  --clear-in-fly: 12px;
  --clear-out-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --clear-in-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --clear-blur: 2px;
  --glow-delay: 50ms;
  --glow-peak-at: 0.15;
  --glow-opacity: 0.42;
  --glow-spread: 1.5;
  --pulse-dur: 1000ms;
  --pulse-count: 1;
  --pulse-min: 0.5;
  --reveal-dur: 400ms;
  --reveal-blur: 2px;
  --reveal-ease: ease-in-out;
  --shimmer-dur: 2000ms;
  --shimmer-base: #7c7c7c;
  --shimmer-highlight: #0d0d0d;
  --shimmer-band: 400%;
  --shimmer-ease: linear;
  --tabs-dur: 250ms;
  --tabs-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tabs-text-muted: rgba(15, 15, 15, 0.8);
  --tabs-text-active: #0f0f0f;
  --tabs-bar-bg: #f1f1f1;
  --tabs-pill-bg: #ffffff;
  --tt-in-dur: 150ms;
  --tt-out-dur: 50ms;
  --tt-scale: 0.98;
  --tt-delay: 80ms;
  --tt-in-ease: ease-out;
  --tt-out-ease: ease-out;
  --tt-bg: #ffffff;
  --tt-fg: #2f2f2f;
  --stagger-dur: 500ms;
  --stagger-distance: 12px;
  --stagger-stagger: 40ms;
  --stagger-blur: 3px;
  --stagger-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tilt-perspective: 1000px;
  --tilt-return: 1000ms;
  --tilt-return-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tilt-follow: 400ms;
  --tilt-follow-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tilt-glare-opacity: 0.32;
  --tilt-glare-fade: 300ms;
  --tilt-glare-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --morph-open-dur: 350ms;
  --morph-close-dur: 250ms;
  --morph-ease: cubic-bezier(0.34, 1.25, 0.64, 1);
  --morph-close-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --morph-r-closed: 40px;
  --morph-r-open: 20px;
  --morph-fade-dur: 200ms;
  --morph-slide: 40px;
  --morph-rotate: 45deg;
  --morph-scale: 0.97;
  --morph-blur: 2px;
  --acc-expand: 250ms;
  --acc-collapse: 250ms;
  --acc-chevron: 250ms;
  --acc-ease: cubic-bezier(0.22, 1, 0.36, 1);
}
.t-resize {
  transition: width var(--resize-dur) var(--resize-ease), height var(--resize-dur) var(--resize-ease);
  will-change: width, height;
}
@media (prefers-reduced-motion: reduce) {
  .t-resize {
    transition: none !important;
  }
}
@keyframes t-digit-pop-in {
  0% {
    transform: translate( calc(var(--digit-distance) * var(--digit-dir-x)), calc(var(--digit-distance) * var(--digit-dir-y)) );
    opacity: 0;
    filter: blur(var(--digit-blur));
  }
  100% {
    transform: translate(0, 0);
    opacity: 1;
    filter: blur(0);
  }
}
.t-digit-group {
  display: inline-flex;
  align-items: baseline;
}
.t-digit {
  display: inline-block;
  will-change: transform, opacity, filter;
}
.t-digit-group.is-animating .t-digit {
  animation: t-digit-pop-in var(--digit-dur) var(--digit-ease) both;
}
.t-digit-group.is-animating .t-digit[data-stagger="1"] {
  animation-delay: var(--digit-stagger);
}
.t-digit-group.is-animating .t-digit[data-stagger="2"] {
  animation-delay: calc(var(--digit-stagger) * 2);
}
@media (prefers-reduced-motion: reduce) {
  .t-digit-group .t-digit {
    animation: none !important;
  }
}
@keyframes t-badge-slide-in {
  from {
    transform: translate(var(--badge-offset-x), var(--badge-offset-y));
  }
  to {
    transform: translate(0, 0);
  }
}
.t-badge {
  position: absolute;
  top: -6px;
  right: -8px;
  pointer-events: none;
  will-change: transform;
}
.t-badge[data-open="true"] {
  animation: t-badge-slide-in var(--badge-slide-dur) var(--badge-slide-ease);
}
.t-badge-dot {
  display: block;
  transform-origin: center;
  transform: scale(1);
  opacity: 1;
  filter: blur(0);
  transition: transform var(--badge-pop-dur) var(--badge-pop-ease), opacity var(--badge-fade-dur) var(--badge-pop-ease), filter var(--badge-pop-dur) var(--badge-pop-ease);
  will-change: transform, opacity, filter;
}
.t-badge[data-open="false"] .t-badge-dot {
  transform: scale(0);
  opacity: 0;
  filter: blur(var(--badge-blur));
  transition: transform var(--badge-pop-close-dur) var(--badge-close-ease), opacity var(--badge-fade-close-dur) var(--badge-close-ease), filter var(--badge-pop-close-dur) var(--badge-close-ease);
}
@media (prefers-reduced-motion: reduce) {
  .t-badge, .t-badge-dot {
    animation: none !important;
    transition: none !important;
  }
}
.t-text-swap {
  display: inline-block;
  transform: translateY(0);
  filter: blur(0);
  opacity: 1;
  transition: transform var(--text-swap-dur) var(--text-swap-ease), filter var(--text-swap-dur) var(--text-swap-ease), opacity var(--text-swap-dur) var(--text-swap-ease);
  will-change: transform, filter, opacity;
}
.t-text-swap.is-exit {
  transform: translateY(calc(var(--text-swap-translate-y) * -1));
  filter: blur(var(--text-swap-blur));
  opacity: 0;
}
.t-text-swap.is-enter-start {
  transform: translateY(var(--text-swap-translate-y));
  filter: blur(var(--text-swap-blur));
  opacity: 0;
  transition: none;
}
@media (prefers-reduced-motion: reduce) {
  .t-text-swap {
    transition: none !important;
  }
}
.t-dropdown {
  transform-origin: top left;
  transform: scale(var(--dropdown-pre-scale));
  opacity: 0;
  pointer-events: none;
  transition: transform var(--dropdown-open-dur) var(--dropdown-ease), opacity var(--dropdown-open-dur) var(--dropdown-ease);
  will-change: transform, opacity;
}
.t-dropdown[data-origin="top-right"] {
  transform-origin: top right;
}
.t-dropdown[data-origin="top-center"] {
  transform-origin: top center;
}
.t-dropdown[data-origin="bottom-left"] {
  transform-origin: bottom left;
}
.t-dropdown[data-origin="bottom-center"] {
  transform-origin: bottom center;
}
.t-dropdown[data-origin="bottom-right"] {
  transform-origin: bottom right;
}
.t-dropdown.is-open {
  transform: scale(1);
  opacity: 1;
  pointer-events: auto;
}
.t-dropdown.is-closing {
  transform: scale(var(--dropdown-closing-scale));
  opacity: 0;
  pointer-events: none;
  transition: transform var(--dropdown-close-dur) var(--dropdown-ease), opacity var(--dropdown-close-dur) var(--dropdown-ease);
}
@media (prefers-reduced-motion: reduce) {
  .t-dropdown {
    transition: none !important;
  }
}
.t-modal {
  transform-origin: center;
  transform: scale(var(--modal-scale));
  opacity: 0;
  pointer-events: none;
  transition: transform var(--modal-open-dur) var(--modal-ease), opacity var(--modal-open-dur) var(--modal-ease);
  will-change: transform, opacity;
}
.t-modal.is-open {
  transform: scale(1);
  opacity: 1;
  pointer-events: auto;
}
.t-modal.is-closing {
  transform: scale(var(--modal-scale-close));
  opacity: 0;
  pointer-events: none;
  transition: transform var(--modal-close-dur) var(--modal-ease), opacity var(--modal-close-dur) var(--modal-ease);
}
@media (prefers-reduced-motion: reduce) {
  .t-modal {
    transition: none !important;
  }
}
.t-panel-slide {
  transform: translateY(var(--panel-translate-y));
  opacity: 0;
  filter: blur(var(--panel-blur));
  pointer-events: none;
  transition: transform var(--panel-close-dur) var(--panel-ease), opacity var(--panel-close-dur) var(--panel-ease), filter var(--panel-close-dur) var(--panel-ease);
  will-change: transform, opacity, filter;
}
.t-panel-slide[data-open="true"] {
  transform: translateY(0);
  opacity: 1;
  filter: blur(0);
  pointer-events: auto;
  transition: transform var(--panel-open-dur) var(--panel-ease), opacity var(--panel-open-dur) var(--panel-ease), filter var(--panel-open-dur) var(--panel-ease);
}
@media (prefers-reduced-motion: reduce) {
  .t-panel-slide {
    transition: none !important;
  }
}
.t-page-slide {
  position: relative;
}
.t-page-slide .t-page[data-page-id="1"] {
  --t-page-from-x: calc(var(--page-slide-distance) * -1);
}
.t-page-slide .t-page[data-page-id="2"] {
  --t-page-from-x: var(--page-slide-distance);
}
.t-page-slide .t-page {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
  transform: translateX(calc(var(--t-page-from-x, 0px) * var(--page-exit-enabled)));
  filter: blur(calc(var(--page-blur) * var(--page-exit-enabled)));
  transition: opacity var(--page-fade-dur) var(--page-fade-ease), transform var(--page-slide-dur) var(--page-slide-ease), filter var(--page-slide-dur) var(--page-slide-ease);
  will-change: opacity, transform, filter;
}
.t-page-slide[data-page="1"] .t-page[data-page-id="1"], .t-page-slide[data-page="2"] .t-page[data-page-id="2"] {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
  filter: blur(0);
  transition-delay: var(--page-stagger);
}
@media (prefers-reduced-motion: reduce) {
  .t-page-slide .t-page {
    transition: none !important;
  }
}
.t-icon-swap {
  position: relative;
  display: inline-grid;
}
.t-icon-swap .t-icon {
  grid-area: 1 / 1;
  transition: opacity var(--icon-swap-dur) var(--icon-swap-ease), filter var(--icon-swap-dur) var(--icon-swap-ease), transform var(--icon-swap-dur) var(--icon-swap-ease);
  will-change: opacity, filter, transform;
}
.t-icon-swap[data-state="a"] .t-icon[data-icon="a"], .t-icon-swap[data-state="b"] .t-icon[data-icon="b"] {
  opacity: 1;
  filter: blur(0);
  transform: scale(1);
}
.t-icon-swap[data-state="a"] .t-icon[data-icon="b"], .t-icon-swap[data-state="b"] .t-icon[data-icon="a"] {
  opacity: 0;
  filter: blur(var(--icon-swap-blur));
  transform: scale(var(--icon-swap-start-scale));
}
@media (prefers-reduced-motion: reduce) {
  .t-icon-swap .t-icon {
    transition: none !important;
  }
}
.t-success-check {
  display: inline-block;
  transform-origin: center;
  opacity: 0;
  will-change: transform, opacity, filter;
}
.t-success-check svg {
  display: block;
  overflow: visible;
}
.t-success-check svg path {
  stroke-dasharray: 20;
  stroke-dashoffset: 20;
}
.t-success-check[data-state="in"] {
  animation: t-check-fade var(--check-opacity-dur) var(--check-ease-opacity) forwards, t-check-rotate var(--check-rotate-dur) var(--check-ease-rotate) forwards, t-check-blur var(--check-blur-dur) var(--check-ease-out) forwards, t-check-bob var(--check-bob-dur) var(--check-ease-bob) forwards;
}
.t-success-check[data-state="in"] svg path {
  animation: t-check-draw var(--check-path-dur) var(--check-ease-path) var(--check-path-delay, 0ms) forwards;
}
@keyframes t-check-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes t-check-rotate {
  from {
    transform: rotate(var(--check-rotate-from));
  }
  to {
    transform: rotate(0deg);
  }
}
@keyframes t-check-blur {
  from {
    filter: blur(var(--check-blur-from));
  }
  to {
    filter: blur(0);
  }
}
@keyframes t-check-bob {
  from {
    translate: 0 var(--check-y-amount);
  }
  to {
    translate: 0 0;
  }
}
@keyframes t-check-draw {
  to {
    stroke-dashoffset: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .t-success-check {
    animation: none !important;
    opacity: 1;
  }
  .t-success-check svg path {
    animation: none !important;
    stroke-dashoffset: 0 !important;
  }
}
.t-avatar {
  transform-origin: center;
  transform: translateY(var(--shift, 0px)) scale(var(--scale-active, 1));
  transition: transform var(--avatar-dur) var(--avatar-ease-in);
  will-change: transform;
}
@media (prefers-reduced-motion: reduce) {
  .t-avatar {
    transition: none !important;
    transform: none !important;
  }
}
.t-input {
  transition: border-color 150ms ease-out;
  will-change: transform;
}
.t-input.is-error {
  transition: border-color var(--revert-dur, 280ms) ease-out;
}
.t-error-msg {
  opacity: 0;
  visibility: hidden;
  transition: opacity var(--revert-dur, 280ms) ease-out, visibility 0s linear var(--revert-dur, 280ms);
}
.t-input-wrap.is-error .t-error-msg {
  opacity: 1;
  visibility: visible;
  transition: opacity var(--revert-dur, 280ms) ease-out, visibility 0s linear 0s;
}
.t-input.is-shaking {
  animation: t-input-shake calc( var(--shake-dur-a) * 2 + var(--shake-dur-b) * 2 ) linear;
}
@keyframes t-input-shake {
  0% {
    transform: translateX(0);
    animation-timing-function: var(--shake-ease);
  }
  28.57% {
    transform: translateX(var(--shake-distance));
    animation-timing-function: var(--shake-ease);
  }
  57.14% {
    transform: translateX(calc(var(--shake-distance) * -1));
    animation-timing-function: var(--shake-ease);
  }
  78.57% {
    transform: translateX(var(--shake-overshoot));
    animation-timing-function: var(--shake-ease);
  }
  100% {
    transform: translateX(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .t-input {
    animation: none !important;
    transform: none !important;
  }
}
.t-clear {
  position: relative;
  overflow: hidden;
}
.t-clear-mirror, .t-clear-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  z-index: 2;
}
.t-clear-mirror {
  opacity: 0;
}
.t-clear.has-value .t-clear-mirror, .t-clear.is-clearing .t-clear-mirror {
  opacity: 1;
}
.t-clear.has-value > input, .t-clear.is-clearing > input {
  -webkit-text-fill-color: transparent;
}
.t-clear.has-value .t-clear-placeholder {
  opacity: 0;
}
.t-clear-glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  z-index: 3;
  mix-blend-mode: multiply;
}
@media (prefers-reduced-motion: reduce) {
  .t-clear-glow {
    opacity: 0 !important;
  }
}
.t-skel {
  position: relative;
}
.t-skel-skeleton, .t-skel-content {
  position: absolute;
  inset: 0;
}
.t-skel-skeleton {
  z-index: 1;
  opacity: 1;
  filter: blur(0);
  transition: opacity var(--reveal-dur) var(--reveal-ease), filter var(--reveal-dur) var(--reveal-ease);
}
.t-skel-content {
  z-index: 2;
  opacity: 0;
  filter: blur(var(--reveal-blur));
  transition: opacity var(--reveal-dur) var(--reveal-ease), filter var(--reveal-dur) var(--reveal-ease);
}
.t-skel.is-revealed .t-skel-skeleton {
  opacity: 0;
  filter: blur(var(--reveal-blur));
}
.t-skel.is-revealed .t-skel-content {
  opacity: 1;
  filter: blur(0);
}
.t-skel.is-resetting .t-skel-skeleton, .t-skel.is-resetting .t-skel-content {
  transition: none !important;
}
.t-skel-skeleton.is-pulsing > * {
  animation: t-skel-pulse var(--pulse-dur) ease-in-out var(--pulse-count);
}
@keyframes t-skel-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: var(--pulse-min);
  }
}
@media (prefers-reduced-motion: reduce) {
  .t-skel-skeleton, .t-skel-content {
    transition: none !important;
  }
  .t-skel-skeleton.is-pulsing > * {
    animation: none !important;
  }
}
.t-shimmer {
  position: relative;
  display: inline-block;
  color: var(--shimmer-base);
}
.t-shimmer::before {
  content: attr(data-text);
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient( 90deg, transparent 0%, transparent 40%, var(--shimmer-highlight) 50%, transparent 60%, transparent 100% );
  background-size: var(--shimmer-band) 100%;
  background-repeat: no-repeat;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: t-shimmer var(--shimmer-dur) var(--shimmer-ease) infinite;
}
@keyframes t-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .t-shimmer::before {
    animation: none !important;
  }
}
.t-tabs {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  border-radius: 48px;
  background: var(--tabs-bar-bg);
}
.t-tab {
  position: relative;
  appearance: none;
  border: 0;
  background: transparent;
  height: 30px;
  padding: 4px 12px;
  color: var(--tabs-text-muted);
  cursor: pointer;
  border-radius: 48px;
  z-index: 1;
  transition: color var(--tabs-dur) var(--tabs-ease);
}
.t-tab:not([aria-selected="true"]):hover, .t-tab[aria-selected="true"] {
  color: var(--tabs-text-active);
}
.t-tabs-pill {
  position: absolute;
  top: 3px;
  left: 0;
  height: 30px;
  width: 0;
  background: var(--tabs-pill-bg);
  border-radius: 48px;
  transform: translateX(0);
  transition: transform var(--tabs-dur) var(--tabs-ease), width var(--tabs-dur) var(--tabs-ease);
  will-change: transform, width;
  z-index: 0;
  pointer-events: none;
}
@media (prefers-reduced-motion: reduce) {
  .t-tabs-pill, .t-tab {
    transition: none !important;
  }
}
.t-tt-wrap {
  position: relative;
  display: inline-block;
}
.t-tt {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translate(-50%, 0) scale(var(--tt-scale));
  transform-origin: 50% 100%;
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--tt-bg);
  color: var(--tt-fg);
  white-space: nowrap;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 2px 6px 0 rgba(0, 0, 0, 0.05), 0 4px 42px 0 rgba(0, 0, 0, 0.06);
  opacity: 0;
  pointer-events: none;
  transition: opacity var(--tt-out-dur) var(--tt-out-ease), transform var(--tt-out-dur) var(--tt-out-ease);
}
.t-tt-wrap:hover .t-tt, .t-tt-trigger:focus-visible + .t-tt {
  opacity: 1;
  transform: translate(-50%, 0) scale(1);
  transition-duration: var(--tt-in-dur);
  transition-timing-function: var(--tt-in-ease);
  transition-delay: var(--tt-delay);
}
@media (prefers-reduced-motion: reduce) {
  .t-tt {
    transition: none !important;
  }
}
.t-stagger-line {
  display: block;
  opacity: 0;
  transform: translateY(var(--stagger-distance));
  filter: blur(var(--stagger-blur));
  transition: opacity var(--stagger-dur) var(--stagger-ease), transform var(--stagger-dur) var(--stagger-ease), filter var(--stagger-dur) var(--stagger-ease);
  will-change: transform, opacity, filter;
}
.t-stagger-line--2 {
  transition-delay: var(--stagger-stagger);
}
.t-stagger.is-shown .t-stagger-line {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}
.t-stagger.is-hiding .t-stagger-line {
  opacity: 0;
  transform: translateY(0);
  filter: blur(0);
  transition: opacity 200ms ease, transform 0s linear, filter 0s linear;
  transition-delay: 0s;
}
@media (prefers-reduced-motion: reduce) {
  .t-stagger-line {
    transition: none !important;
  }
}
.t-tilt {
  touch-action: none;
}
.t-tilt-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transform: perspective(var(--tilt-perspective)) rotateX(var(--tilt-rx, 0deg)) rotateY(var(--tilt-ry, 0deg));
  transform-style: preserve-3d;
  transition: transform var(--tilt-return) var(--tilt-return-ease);
  will-change: transform;
}
.t-tilt-card.is-tilting {
  transition: transform var(--tilt-follow) var(--tilt-follow-ease);
}
.t-tilt-glare {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  mix-blend-mode: screen;
  background: radial-gradient(circle 95px at var(--tilt-gx, 50%) var(--tilt-gy, 50%), rgba(255,255,255,0.48), rgba(255,255,255,0.06) 52%, rgba(255,255,255,0) 84%), radial-gradient(circle 200px at var(--tilt-gx, 50%) var(--tilt-gy, 50%), rgba(255,255,255,0.22), rgba(255,255,255,0.04) 58%, rgba(255,255,255,0) 78%), radial-gradient(circle 360px at var(--tilt-gx, 50%) var(--tilt-gy, 50%), rgba(255,255,255,0.10), rgba(255,255,255,0) 88%);
  transition: opacity var(--tilt-glare-fade) var(--tilt-glare-ease);
}
.t-tilt.is-hover .t-tilt-glare {
  opacity: var(--tilt-glare-opacity);
}
@media (prefers-reduced-motion: reduce) {
  .t-tilt-card {
    transform: none !important;
    transition: none !important;
  }
}
.t-morph {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: var(--morph-r-closed);
  overflow: hidden;
  transition: width var(--morph-close-dur) var(--morph-close-ease), height var(--morph-close-dur) var(--morph-close-ease), border-radius var(--morph-close-dur) var(--morph-close-ease);
}
.t-morph[data-open="true"] {
  width: 183px;
  height: 172px;
  border-radius: var(--morph-r-open);
  transition: width var(--morph-open-dur) var(--morph-ease), height var(--morph-open-dur) var(--morph-ease), border-radius var(--morph-open-dur) var(--morph-ease);
}
.t-morph-plus {
  position: absolute;
  inset: auto 0 0 auto;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  transition: opacity var(--morph-fade-dur) var(--morph-close-ease), transform var(--morph-open-dur) var(--morph-close-ease), filter var(--morph-fade-dur) var(--morph-close-ease);
}
.t-morph-plus svg {
  transition: transform var(--morph-open-dur) var(--morph-close-ease);
}
.t-morph[data-open="true"] .t-morph-plus {
  opacity: 0;
  transform: translateX(calc(-1 * var(--morph-slide)));
  filter: blur(var(--morph-blur));
  pointer-events: none;
}
.t-morph[data-open="true"] .t-morph-plus svg {
  transform: scale(var(--morph-scale)) rotate(var(--morph-rotate));
}
.t-morph-menu {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: translateX(var(--morph-slide)) scale(var(--morph-scale));
  filter: blur(var(--morph-blur));
  pointer-events: none;
  transition: opacity var(--morph-fade-dur) var(--morph-close-ease), transform var(--morph-open-dur) var(--morph-close-ease), filter var(--morph-fade-dur) var(--morph-close-ease);
}
.t-morph[data-open="true"] .t-morph-menu {
  opacity: 1;
  transform: translateX(0) scale(1);
  filter: blur(0);
  pointer-events: auto;
}
@media (prefers-reduced-motion: reduce) {
  .t-morph, .t-morph-plus, .t-morph-menu {
    transition: none !important;
  }
}
.t-acc-panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows var(--acc-collapse) var(--acc-ease);
}
.t-acc[data-open="true"] .t-acc-panel {
  grid-template-rows: 1fr;
  transition: grid-template-rows var(--acc-expand) var(--acc-ease);
}
.t-acc-panel-inner {
  overflow: hidden;
  opacity: 0;
  filter: blur(2px);
  transition: opacity var(--acc-collapse) var(--acc-ease), filter var(--acc-collapse) var(--acc-ease);
}
.t-acc[data-open="true"] .t-acc-panel-inner {
  opacity: 1;
  filter: blur(0);
  transition: opacity var(--acc-expand) var(--acc-ease), filter var(--acc-expand) var(--acc-ease);
}
.t-acc-chevron {
  display: inline-flex;
  transform: scaleY(1);
  transform-origin: center;
  transition: transform var(--acc-chevron) var(--acc-ease);
}
.t-acc-chevron path {
  vector-effect: non-scaling-stroke;
}
.t-acc[data-open="true"] .t-acc-chevron {
  transform: scaleY(-1);
}
@media (prefers-reduced-motion: reduce) {
  .t-acc-panel, .t-acc-panel-inner, .t-acc-chevron {
    transition: none !important;
  }
}
:root {
  --tabs-bar-bg: var(--color-gray-100);
  --tabs-pill-bg: #ffffff;
  --tabs-text-muted: var(--color-gray-600);
  --tabs-text-active: var(--color-primary-900);
  --tt-bg: var(--color-primary-950);
  --tt-fg: #ffffff;
}
.t-tabs {
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  font-family: var(--font-body);
}
.t-tab {
  height: 36px;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
}
.t-tabs-pill {
  top: 4px;
  height: 36px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.1);
}
.t-tabs--underline {
  gap: 0.25rem;
  padding: 0;
  border-radius: 0;
  background: transparent;
  border-bottom: 1px solid var(--color-gray-200);
}
.t-tabs--underline .t-tab {
  height: 42px;
  padding: 8px 14px;
  border-radius: 8px 8px 0 0;
  font-weight: 500;
}
.t-tabs--underline .t-tab:not([aria-selected="true"]):hover {
  background: var(--color-gray-50);
}
.t-tabs--underline .t-tab[aria-selected="true"] {
  font-weight: 600;
}
.t-tabs--underline .t-tabs-pill {
  top: auto;
  bottom: -1px;
  height: 2px;
  border-radius: 999px;
  background: var(--color-primary-900);
  box-shadow: none;
}
.t-tabs--underline .t-tab[aria-selected="true"] {
  background: var(--color-primary-50);
}
@keyframes t-tab-panel-in {
  from {
    opacity: 0;
    transform: translateY(6px);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}
.t-tab-panel.is-entering {
  animation: t-tab-panel-in var(--duration-fast) var(--ease-smooth-out) both;
}
@media (prefers-reduced-motion: reduce) {
  .t-tab-panel.is-entering {
    animation: none \\ !important;
  }
}
@font-face {
  font-family: "Barlow";
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
@font-face {
  font-family: "Barlow";
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}
@font-face {
  font-family: "Barlow";
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
@font-face {
  font-family: "Barlow";
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}
@font-face {
  font-family: "Barlow Condensed";
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
}
@font-face {
  font-family: "Barlow Condensed";
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
}
@font-face {
  font-family: "Barlow Condensed";
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2");
}
@layer base {
  html {
    font-size: 16px;
  }
  body {
    font-family: var(--font-body);
    line-height: 1.6;
    color: var(--color-primary-900);
  }
  p {
    line-height: 1.6;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-display);
    font-weight: 600;
    letter-spacing: -0.01em;
    color: var(--color-primary-900);
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-space-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-divide-y-reverse: 0;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/app/styles/elixir-lu-ui/tokens.css","webpack://./src/app/styles/elixir-lu-ui/components.css","webpack://./src/app/styles/globals.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;ICkEA,+EACoE;IAIpE,wFAC6E;IDvC3E,2CAA2C;IAG3C,4CAA4C;IAM5C,4CAA4C;IA2B5C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,4CAA4C;IAG5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAoJ7C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAE5C,0CAA0C;IAuF1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAWlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IAErB,sBAAsB;IAGtB,sBAAsB;IAItB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAG3C,gBAAgB;IAChB,0BAA0B;IAa1B,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAM3B,0BAA0B;IAE1B,wBAAwB;IAIxB,qBAAqB;IACrB,qBAAqB;IAErB,wBAAwB;IAIxB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IA0ClB,uCAAuC;IAsDvC,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;ICxb3D,+EACoE;IACpE,oEAAoE;IAKpE,4CAA6C;IAC7C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAG9C,0CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAC5C,4CAA4C;IAG5C,yCAA0C;IAC1C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAI3C,2BAA2B;EDnHZ;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,gFAAmB;MAAnB,wFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,qDAAmB;IAAnB;MAAA,2FAAmB;IAAA;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,kDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,sEAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,kEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB;MAAA,qEAAmB;IAAA;EAAA;EAAnB;IAAA,+BAAmB;IAAnB;MAAA,qEAAmB;IAAA;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,iFAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,sEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,uEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mIAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,kLAAmB;IAAnB,gGAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,qDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0CAAmB;QAAnB;UAAA,gFAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,uCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB;QAAA,gFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yCAAmB;MAAnB;QAAA,+EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB,4GAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB,sDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0CAAmB;MAAnB;QAAA,gFAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,0CAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA,8BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;MAAnB,oBAAmB;MAAnB,4BAAmB;MAAnB,qBAAmB;IAAA;EAAA;AADJ;AC76BjB;;;;;;;;;;;;;;;;EAgBG;AAGH;EAEE,4BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAG7B,2BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAI5B,4BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAvCzB;ACnBN;;;;;;;;;;;;EAYG;AAEH;EAEE;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,+BAAU;IACnE,0CAAc;IADsD,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IACpF,8BAAe;IADsE,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IACtF;MAAA;QAAA,0CACtB;MAAA;IAAA;IAAC;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAAC;MAAA,wHACZ;MADY,sIACZ;IAAA;IAAC;MAAA,yCAA8B;IAAA;IAAC;MAAA,2BAA2B;MAA3B,4GAA2B;IAAA;EAJ7D;EAOb;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,sCAAkB;IAAC,oCAAQ;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IACtI,+BAAgB;IADuH,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IACvI;MAAA;QAAA,0CACR;MAAA;IAAA;IAAC;MAAA;QAAA,8BAAqB;MAAA;IAAA;IAAC;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAAC;MAAA,wHAClC;MADkC,sIAClC;IAAA;IAAC;MAAA,yCAA8B;IAAA;IAAC;MAAA,2BAA2B;MAA3B,4GAA2B;IAAA;EAJ3D;EASf;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,qCAAiB;IAAC,oCAAQ;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IACrI,8BAAe;IADuH,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IACvI;MAAA;QAAA,yCACR;MAAA;IAAA;IAAC;MAAA;QAAA,8BAAqB;MAAA;IAAA;IAAC;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;IAAC;MAAA,wHACjC;MADiC,sIACjC;IAAA;IAAC;MAAA,wCAA6B;IAAA;IAAC;MAAA,2BAA2B;MAA3B,4GAA2B;IAAA;EAJ7D;EAQZ;IACS,oBAAW;IAAC,mBAAY;IAAC,6BAAK;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,wCAAI;IAAC,yCAAM;IAAC,gCAAY;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAW,qBAAiB;IAAjB,sBAAiB;IAC/J,+BAAgB;IADoH,yBAAS;IAAmB,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAChK;MAAA;QAAA,sCACJ;MAAA;IAAA;IAAC;MAAA;QAAA,0CAAoB;MAAA;IAAA;IAAC;MAAA;QAAA,8BAAqB;MAAA;IAAA;IAAC;MAAA,sCAAqB;MAArB,kBAAqB;IAAA;IAC9E;MAAA,sCAAuB;MAAvB,kBAAuB;IAAA;IAAC;MAAA,mBAA8B;IAAA;IAAC;MAAA,uCAAiC;IAAA;EAJ5E;EAMV;IAES,mBAAkB;IAAC,mCAAe;IAAC,4BAAa;IAC3D;MAAA;QAAA,mCAAqB;MAAA;IAAA;IAAC;MAAA;QAAA,oCAAc;MAAA;IAAA;IAAC;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAFtB;EAMhC;IACS,oBAAW;IAAC,gCAAG;IAAC,mCAAO;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,wCAAI;IAAC,gCAAY;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IACjJ,+BAAgB;IADkI,kCAAY;IAAZ,iJAAY;IAAC,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAC/J;MAAA;QAAA,sCACJ;MAAA;IAAA;IAAC;MAAA;QAAA,0CAAoB;MAAA;IAAA;IAAC;MAAA;QAAA,8BAAqB;MAAA;IAAA;EAH5C;EAKV;IACS,oBAAW;IAAC,gCAAG;IAAC,mCAAO;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,sCAAkB;IAAC,0CAAc;IAAC,wCAAI;IAAC,gCAAY;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAC1J,8BAAe;IAD4I,kCAAY;IAAZ,iJAAY;EADnJ;EAMlB;IACS,oBAAW;IAAC,gCAAG;IAAC,+BAAG;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAC5F,+BAAgB;IAD6E,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAC7F;MAAA;QAAA,sCACJ;MAAA;IAAA;IAAC;MAAA;QAAA,sCAAgB;MAAA;IAAA;EAHlB;EAKV;IACS,oBAAW;IAAC,gCAAG;IAAC,+BAAG;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,qCAAiB;IAAC,oCAAQ;IACvG,8BAAe;IADyF,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IACzG;MAAA;QAAA,qCACJ;MAAA;IAAA;IAAC;MAAA;QAAA,yCAAmB;MAAA;IAAA;IAAC;MAAA;QAAA,8BAAqB;MAAA;IAAA;IAAC;MAAA,sCAAqB;MAArB,kBAAqB;IAAA;IAC5E;MAAA,sCAAuB;MAAvB,kBAAuB;IAAA;IAAC;MAAA,mBAA8B;IAAA;IAAC;MAAA,sCAAgC;IAAA;IAAC;MAAA,mBAA2B;IAAA;IAAC;MAAA,mCACjG;IAAA;IAAC;MAAA,4BAAsB;IAAA;IAAC;MAAA;QAAA;UAAA,oCAAuB;QAAA;MAAA;IAAA;IAAC;MAAA;QAAA;UAAA,4BAA4B;QAAA;MAAA;IAAA;EAL5E;EASjB;IACS,uCAAI;IAAC,cAAK;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,+BAAgB;EAD5C;EAGZ;IACS,+BAAS;IAAC,0BAAkB;IAAC;MAAA;QAAA,+BAAsB;MAAA;IAAA;EAD9C;EAId;IACS,uCAAM;IAAC,8BAAe;EADhB;EAIf;IACS,cAAK;IAAC,WAAM;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,wCAAI;IAAC,uCAAI;IAC5E,+BAAgB;IAD6D,0HAAS;IAAT,sIAAS;IACrE;MAAA,sCACJ;IAAA;IAAoB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAtD;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;EAHlB;EAKZ;IACS,qCAAiB;IAAC;MAAA,qCAAuB;IAAA;IAAC;MAAA,wCAAqB;IAAA;EADtD;EAGlB;IACS,cAAK;IAAC,WAAM;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,wCAAI;IAAC,uCAAI;IAC5E,+BAAgB;IAD6D,0HAAS;IAAT,sIAAS;IACrE;MAAA,sCACJ;IAAA;IAAoB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAtD;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;EAHf;EAKf;IACS,cAAK;IAAC,WAAM;IAAC,eAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,iCAAG;IAAC,yBAAO;IAAP,2DAAO;IAAC,4BAAa;IAAC,0HAAS;IAAT,sIAAS;IACrH;MAAA,sCAAS;IAAA;IAAC;MAAA,eAAmB;IAAA;IAAC;MAAA,oCAAW;MAAX,iBAAW;IAAA;IAAC;MAAA,sCAAuB;IAAA;IAAC;MAAA,oCAAa;IAAA;IAAC;MAAA,wCAAS;IAAA;IAAC;MAAA,uCAAS;IAAA;IAAC;MAAA,yBAAY;MAAZ,2DAAY;IAAA;IAAC;MAAA,6CAAkB;MAAlB,wCAAkB;IAAA;IAAC;MAAA,+BAAqB;IAAA;IAAC;MAAA,uKAAsB;MAAtB,qFAAsB;MAAtB,2EAAsB;IAAA;IAAC;MAAA;QAAA;UAAA,0CACnK;QAAA;MAAA;IAAA;IAAC;MAAA;QAAA;UAAA,8BAA0B;QAAA;MAAA;IAAA;IAAC;MAAA,sCACxC;IAAA;IAAoB;MAAA,wHAAY;MAAZ,sIAAY;IAAA;IAAC;MAAA,yCAAsB;IAAA;IAAtD;MAAA,wBAAkB;MAAlB,mBAAkB;IAAA;EAJR;EAMX;IACS,gCAAG;IAAC,+BAAG;IAAC,+BAAU;IAAC,mCAAe;IAAC,+BAAgB;IAAC;MAAA,yCAAsB;IAAA;EADpE;EAGf;IACS,oCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,oCAAe;IAAf,mCAAe;IAAC,4BAAa;EADxC;EAGX;IACS,oCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,8BAAe;EADzB;EAKZ;IACS,kBAAQ;IAAC,uCAAI;IAAC,aAAI;IAAC,uBAAW;IAAC,6BAAK;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,wCAAI;IAAC,uCAAI;IAAC,+BAAgB;EADnF;EAGP;IACS,qCAAiB;IAAC,wCAAY;EAD1B;EAGb;IACS,sCAAkB;IAAC,yCAAa;EAD7B;EAIZ;IACS,+BAAgB;IAAC;MAAA;QAAA,+BAAsB;MAAA;IAAA;EADnC;EAKb;IACS,oBAAW;IAAC,mBAAY;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,4BAAa;EADvG;EAGP;IACS,oBAAW;IAAC,mBAAY;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,sCAAU;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IACpG,+BAAgB;IADqF,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IACrG;MAAA;QAAA,sCACJ;MAAA;IAAA;IAAC;MAAA;QAAA,uCAAiB;MAAA;IAAA;EAHjB;EAQZ;IACS,oBAAW;IAAC,mBAAY;IAAC,+BAAU;IAAC,0CAAc;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,8BAAe;EAD9F;EAMb;IACS,oBAAW;IAAC,mBAAY;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,sCAAU;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,+BAAgB;EADvG;EAKZ;IACS,sCAAI;IAAC,uCAAI;IAAC,oBAAW;IAAC,gBAAe;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,yBAAO;IAAP,2DAAO;EAD3E;EAGb;IACS,uCAAW;IAAC,wCAAI;IAAC,yCAAM;IAAC,2CAAW;IAAX,sCAAW;IAAC,4BAAa;EADzC;EAGjB;IACS,oCAAQ;IAAC,wCAAI;IAAC,yCAAM;IAAC,+BAAgB;EAD3B;EAKnB;IACS,gCAAW;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,0HAAS;IAAT,sIAAS;EADxD;EAON;IACS,2CAAW;IAAC,uCAAI;IAAC;MAAA,uCAAO;IAAA;EAD1B;EAGP;IACS,aAAI;IAAC,eAAc;IAAC,qBAAS;IAAC,mBAAY;IAAC,8BAAe;IAAC,6BAAK;EAD1D;EAGf;IACE,aAAa;EADwB;EAGvC;IACS,gCAAY;IAAC,yBAAO;IAAP,2DAAO;IAAe,kCAAa;IAAb,iCAAa;IAA3B,6CAAa;IAAb,wCAAa;IAAe,oCAAc;IAAd,qCAAc;IAAC,+BAAgB;IAAC;MAAA,0BAAW;MAAX,4DAAW;IAAA;EADxF;EAGb;IACS,gCAAG;IAAC,+BAAG;IAAC,4BAAa;IAAC,wDAAoB;IAApB,qFAAoB;IAApB,2EAAoB;EADvC;EAGZ;IACS,cAAU;EADa;EAGhC;IACS,oCAAI;EADD;EAKZ;IACS;MAAA,wBAAQ;MAAR,2CAAQ;MAAR,wCAAQ;MAAR,wDAAQ;MAAR,qEAAQ;IAAA;IAAC;MAAA,mCAAe;IAAA;IAAC,0CAAQ;IAAR,uBAAQ;IAAC,mCAAe;EAD/C;EAKX;IACS,aAAI;IAAC,gDAAW;IAAC,6BAAK;IAAC,uCAAI;IAAC;MAAA,6BAAQ;IAAA;EADnC;EAGV;IACE;MACE,2CAA2C;IADnC;EADc;EAK1B;IAES,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,4BAAa;EAD1B;EAGhB;IAES,yBAAO;IAAP,2DAAO;IAAC,oCAAe;IAAf,mCAAe;IAAC,+BAAgB;EADjC;EAKhB;IACS,sCAAU;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,oCAAe;IAAf,mCAAe;IAAC,+BAAgB;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;EADtE;EAGb;IACS,+BAAgB;IAAC,+BAAS;IAAC,0BAAkB;IAAC;MAAA;QAAA,+BAAsB;MAAA;IAAA;EAD9D;EAOf;IACS,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,yBAAa;IAAb,oBAAa;IAAC,mCAAe;IAAC,wCAAI;IAAC,uCAAI;IAAC,kBAAW;EADjE;EAGb;IACS,yBAAO;IAAP,2DAAO;IAAC,4BAAa;EADZ;EAKlB;IACS,eAAU;IAAC,yBAAe;IAAC,yBAAO;IAAP,2DAAO;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;EAD5C;EAGZ;IAES,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,wCAAI;IAAC,uCAAI;IAAC,mBAAS;IAAC,+BAAgB;EADrD;EAGf;IAES,sCAAU;IAAC,6CAAa;IAAb,wCAAa;EADJ;EAK7B;IACS,+BAAgB;IAAC,+BAAS;IAAC,0BAAkB;IAAC;MAAA;QAAA,+BAAsB;MAAA;IAAA;EADvE;EASN;IACS,oBAAW;IAAC,mBAAY;IAAC,6BAAK;IAAC,+BAAU;IAAC,uCAAW;IAAC,iCAAG;IAAC,6BAAS;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,4BAAa;EADxG;EAGN;IACS,+BAAU;IAAC,wCAAI;IAAC,yCAAM;IAAC,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC;MAAA;QAAA,+BAAsB;MAAA;IAAA;EADnE;EAGL;IACS,+BAAU;IAAC,oCAAQ;IAAC,wCAAI;IAAC,yCAAM;IAAC,6CAAa;IAAb,wCAAa;IAAC,+BAAgB;IAAC,0HAAS;IAAT,sIAAS;EADrE;EAQZ;IACS,aAAI;IAAC,6BAAK;IAAC,gBAAe;IAAC,2CAAQ;IAAR,wBAAQ;IAAC,mCAAe;EAD5C;EAGhB;IACS,mBAAM;IAAgB,cAAQ;IAAvB,eAAc;IAAU,2CAAU;IAAV,wBAAU;IAAC,yBAAkB;IAAC,wCAAI;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,4BAAa;IACnH,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC;MAAA;QAAA,mCAAqB;MAAA;IAAA;IAAC;MAAA;QAAA,+BAAsB;MAAA;IAAA;IAAC;MAAA,yBAA6B;IAAA;EAF3E;EAIf;IACS,sCAAkB;IAAC,6CAAa;IAAb,wCAAa;IAAC,+BAAgB;EADrB;EAMrC;IACS,uCAAI;IAAC,aAAI;IAAC,gCAAG;IAAC,qBAAS;IAAC,2CAAQ;IAAR,wBAAQ;IAAC,mCAAe;IAAC,wCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAa,eAAY;IAAZ,cAAY;IAAxB,2CAAW;IAAX,sCAAW;IAAc,4BAAa;EAD9F;EAGf;IACS;MAAA,uBAAW;MAAX,gFAAW;MAAX,wFAAW;IAAA;EADR;EAIZ;IACS,wCAAK;IAAC,aAAI;IAAC,mBAAY;IAAC,6BAAK;IAAC,+BAAU;IAAC,wCAAI;IAAC,yCAAM;IAAC,yBAAO;IAAP,2DAAO;IAAC,+BAAgB;IAAC,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC;MAAA;QAAA,sCAAgB;MAAA;IAAA;EADlH;EAGP;IACS,sCAAU;IAAC;MAAA;QAAA,uCAAiB;MAAA;IAAA;EADrB;EAIhB;IACS,aAAI;IAAC,gCAAG;IAAC,+BAAG;IAAC,cAAQ;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,oCAAQ;IAAC,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;EAD1G;EAGb;IACS,sCAAkB;EADD;EAG1B;IACS,sCAAkB;IAAC,0CAAc;EADb;EAG7B;IACS,mCAAO;IAAC,OAAM;IAAC,gBAAQ;IAAR,uBAAQ;IAAR,mBAAQ;EADnB;EAGb;IACS,cAAQ;IAAC,yBAAO;IAAP,2DAAO;IAAc,4BAAa;IAA1B,kCAAY;IAAZ,iJAAY;EADzB;EAKb;IACS,gCAAY;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,+BAAgB;EAD9C;EAGd;IACS,gCAAY;IAAC,0BAAQ;IAAR,4DAAQ;IAAC,2CAAW;IAAX,sCAAW;IAAC,oCAAc;IAAd,qCAAc;IAAC,+BAAgB;IAAC;MAAA,0BAAW;MAAX,4DAAW;IAAA;EAD1E;EAGZ;IACS,eAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,iCAAY;IAAZ,gCAAY;IAAC,+BAAgB;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EAD1D;EAKX;IACS,2CAAQ;IAAR,wBAAQ;IAAC,mCAAe;IAAC,oCAAQ;EADlC;EAIR;IACS,cAAK;IAAC,+BAAU;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC,+BAAgB;IAAC,uKAAiB;IAAjB,qFAAiB;IAAjB,2EAAiB;IAAC;MAAA;QAAA,uCAAiB;MAAA;IAAA;EADlG;EAGV;IACS,cAAK;IAAC,+BAAU;IAAC,wCAAI;IAAC,uCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,+BAAgB;IAAC,+BAAS;IAAC,+CAAsB;IAAC,8BAAY;IAAC,0BAAkB;EAD1H;EAMjB;IACS,0CAAc;IAAC,gDAAa;IAAb;MAAA,+DAAa;IAAA;EADzB;EAIZ;IACS,aAAI;IAAC,iCAAI;IAAC,WAAM;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC,wCAAI;IAAC,uCAAI;IAAC,YAAU;IAAC,yUAAU;IAAV,qFAAU;IAAV,2EAAU;IAAC;MAAA;QAAA,mCAAqB;MAAA;IAAA;IAAC;MAAA;QAAA,aAAiB;MAAA;IAAA;EADjJ;AA5UE;AA4VlB;EAEE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,iDAAiD;EACjD,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,gDAAgD;EAChD,uDAAuD;EACvD,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EAGjB,mBAAmB;EACnB,6CAA6C;EAE7C,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAEhB,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,kDAAkD;EAClD,mDAAmD;EACnD,gDAAgD;EAEhD,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;EAE7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,+CAA+C;EAE/C,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAE5C,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;EACjB,4CAA4C;EAE5C,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,iDAAiD;EACjD,gDAAgD;EAEhD,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAE7B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,gDAAgD;EAChD,oDAAoD;EACpD,mDAAmD;EACnD,mDAAmD;EACnD,iDAAiD;EAEjD,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,gDAAgD;EAChD,oDAAoD;EAEpD,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,qBAAqB;EACrB,mBAAmB;EAEnB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,gDAAgD;EAChD,+CAA+C;EAC/C,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAElB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAE1B,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;EAEtB,iBAAiB;EACjB,2CAA2C;EAC3C,wCAAwC;EACxC,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EAEvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAEhB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAE9C,0BAA0B;EAC1B,qBAAqB;EACrB,kDAAkD;EAClD,oBAAoB;EACpB,kDAAkD;EAClD,0BAA0B;EAC1B,wBAAwB;EACxB,iDAAiD;EAEjD,uBAAuB;EACvB,wBAAwB;EACxB,+CAA+C;EAC/C,kDAAkD;EAClD,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EAEjB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,0CAA0C;AA/LtC;AAmMN;EACE,mGAE6C;EAC7C,0BAA0B;AAJlB;AAMV;EACE;IAAY,2BAA2B;EAA7B;AAD4B;AAKxC;EACE;IACE,0HAGC;IACD,UAAU;IACV,+BAA+B;EAN5B;EAQL;IAAO,0BAA0B;IAAE,UAAU;IAAE,eAAe;EAAzD;AATmB;AAW1B;EACE,oBAAoB;EACpB,qBAAqB;AAFR;AAIf;EACE,qBAAqB;EACrB,uCAAuC;AAFhC;AAIT;EACE,iEAAiE;AAD9B;AAGrC;EACE,qCAAqC;AADgB;AAGvD;EACE,+CAA+C;AADM;AAGvD;EACE;IAA0B,0BAA0B;EAA5B;AADc;AAKxC;EACE;IAAO,kEAAkE;EAApE;EACL;IAAO,0BAA0B;EAA5B;AAFqB;AAI5B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AALf;AAOT;EACE,0EAA0E;AADjD;AAG3B;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,wKAGuD;EACvD,uCAAuC;AAV5B;AAYb;EACE,mBAAmB;EACnB,UAAU;EACV,+BAA+B;EAC/B,gMAG+D;AAPxB;AASzC;EACE;IAAyB,0BAA0B;IAAE,2BAA2B;EAAzD;AADe;AAKxC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,uKAGsD;EACtD,uCAAuC;AAT5B;AAWb;EACE,8DAA8D;EAC9D,mCAAmC;EACnC,UAAU;AAHS;AAKrB;EACE,mDAAmD;EACnD,mCAAmC;EACnC,UAAU;EACV,gBAAgB;AAJU;AAM5B;EACE;IAAe,2BAA2B;EAA7B;AADyB;AAKxC;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,UAAU;EACV,oBAAoB;EACpB,0HAEyD;EACzD,+BAA+B;AARrB;AAUZ;EAA2C,2BAA2B;AAA7B;AACzC;EAA2C,4BAA4B;AAA9B;AACzC;EAA2C,6BAA6B;AAA/B;AACzC;EAA2C,+BAA+B;AAAjC;AACzC;EAA2C,8BAA8B;AAAhC;AACzC;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AAHF;AAKpB;EACE,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;EACpB,4HAE0D;AANrC;AAQvB;EACE;IAAc,2BAA2B;EAA7B;AAD0B;AAKxC;EACE,wBAAwB;EACxB,oCAAoC;EACpC,UAAU;EACV,oBAAoB;EACpB,8GAEmD;EACnD,+BAA+B;AARxB;AAUT;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AAHL;AAKjB;EACE,0CAA0C;EAC1C,UAAU;EACV,oBAAoB;EACpB,gHAEoD;AANlC;AAQpB;EACE;IAAW,2BAA2B;EAA7B;AAD6B;AAKxC;EACE,+CAA+C;EAC/C,UAAU;EACV,+BAA+B;EAC/B,oBAAoB;EACpB,iKAGoD;EACpD,uCAAuC;AAT1B;AAWf;EACE,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,8JAGmD;AARpB;AAUjC;EACE;IAAiB,2BAA2B;EAA7B;AADuB;AAKxC;EACE,kBAAkB;AADN;AAGd;EACE,sDAAsD;AADhB;AAGxC;EACE,2CAA2C;AADL;AAGxC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,iFAAiF;EACjF,+DAA+D;EAC/D,2KAGwD;EACxD,uCAAuC;AAXnB;AAatB;EAEE,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,qCAAqC;AALgB;AAOvD;EACE;IAAwB,2BAA2B;EAA7B;AADgB;AAKxC;EACE,kBAAkB;EAClB,oBAAoB;AAFT;AAIb;EACE,gBAAgB;EAChB,uKAGsD;EACtD,uCAAuC;AANpB;AAQrB;EAEE,UAAU;EACV,eAAe;EACf,mBAAmB;AAH+B;AAKpD;EAEE,UAAU;EACV,mCAAmC;EACnC,8CAA8C;AAHI;AAKpD;EACE;IAAuB,2BAA2B;EAA7B;AADiB;AAKxC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,UAAU;EACV,uCAAuC;AAJxB;AAMjB;EAAuB,cAAc;EAAE,iBAAiB;AAAnC;AACrB;EACE,oBAAoB;EACpB,qBAAqB;AAFG;AAI1B;EACE,iSAI4E;AAL5C;AAOlC;EACE,0GAA0G;AADjE;AAG3C;EAA0B;IAAO,UAAU;EAAZ;EAAgB;IAAK,UAAU;EAAZ;AAA1B;AACxB;EACE;IAAO,2CAA2C;EAA7C;EACL;IAAO,uBAAuB;EAAzB;AAFmB;AAI1B;EACE;IAAO,oCAAoC;EAAtC;EACL;IAAO,eAAe;EAAjB;AAFiB;AAIxB;EACE;IAAO,kCAAkC;EAApC;EACL;IAAO,cAAc;EAAhB;AAFgB;AAIvB;EAA0B;IAAK,oBAAoB;EAAtB;AAAL;AACxB;EACE;IAAmB,0BAA0B;IAAE,UAAU;EAAxC;EACjB;IAA4B,0BAA0B;IAAE,+BAA+B;EAA7D;AAFY;AAMxC;EACE,wBAAwB;EACxB,sEAE+B;EAC/B,6DAA6D;EAC7D,sBAAsB;AANd;AAQV;EACE;IAAY,2BAA2B;IAAE,0BAA0B;EAAzD;AAD4B;AAKxC;EACE,uCAAuC;EACvC,sBAAsB;AAFf;AAIT;EACE,0DAA0D;AAD1C;AAGlB;EACE,UAAU;EACV,kBAAkB;EAClB,oGAE+C;AALpC;AAOb;EACE,UAAU;EACV,mBAAmB;EACnB,8EAEyB;AALS;AAOpC;EACE,uFAEU;AAHQ;AAKpB;EACE;IAAU,wBAAwB;IAAkC,4CAA4C;EAAxG;EACR;IAAU,4CAA4C;IAAc,4CAA4C;EAAxG;EACR;IAAU,uDAAuD;IAAE,4CAA4C;EAAvG;EACR;IAAU,6CAA6C;IAAa,4CAA4C;EAAxG;EACR;IAAU,wBAAwB;EAA1B;AALe;AAOzB;EACE;IAAW,0BAA0B;IAAE,0BAA0B;EAAxD;AAD6B;AAKxC;EACE,kBAAkB;EAClB,gBAAgB;AAFT;AAIT;EAEE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AARS;AAUrB;EAAkB,UAAU;AAAZ;AAChB;EACuC,UAAU;AAAZ;AACrC;EAEE,oCAAoC;AADT;AAG7B;EAA0C,UAAU;AAAZ;AACxC;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,wBAAwB;AANZ;AAQd;EACE;IAAgB,qBAAqB;EAAvB;AADwB;AAKxC;EAAU,kBAAkB;AAApB;AACR;EAEE,kBAAkB;EAClB,QAAQ;AAFM;AAIhB;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,qGAE8C;AAN/B;AAQjB;EACE,UAAU;EACV,UAAU;EACV,gCAAgC;EAChC,qGAE8C;AANhC;AAQhB;EACE,UAAU;EACV,gCAAgC;AAFG;AAIrC;EACE,UAAU;EACV,eAAe;AAFmB;AAIpC;EAEE,2BAA2B;AADQ;AAGrC;EACE,uEAAuE;AADzC;AAGhC;EACE;IAAW,UAAU;EAAZ;EACT;IAAW,yBAAyB;EAA3B;AAFa;AAIxB;EACE;IACE,2BAA2B;EADK;EAGlC;IAAkC,0BAA0B;EAA5B;AAJM;AAQxC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;AAHjB;AAKX;EACE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,4IAOC;EACD,yCAAyC;EACzC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,oEAAoE;AAnBnD;AAqBnB;EACE;IAAO,2BAA2B;EAA7B;EACL;IAAO,yBAAyB;EAA3B;AAFc;AAIrB;EACE;IAAqB,0BAA0B;EAA5B;AADmB;AAKxC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAPxB;AASR;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,kDAAkD;AAX7C;AAaP;EAEE,8BAA8B;AADH;AAG7B;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,8FAE4C;EAC5C,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;AAdT;AAgBb;EACE;IAAuB,2BAA2B;EAA7B;AADiB;AAKxC;EACE,kBAAkB;EAClB,qBAAqB;AAFZ;AAIX;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,oDAAoD;EACpD,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,4GAGkC;EAClC,UAAU;EACV,oBAAoB;EACpB,wGAEgD;AAnB5C;AAqBN;EAEE,UAAU;EACV,sCAAsC;EACtC,qCAAqC;EACrC,6CAA6C;EAC7C,iCAAiC;AALC;AAOpC;EACE;IAAQ,2BAA2B;EAA7B;AADgC;AAKxC;EACE,cAAc;EACd,UAAU;EACV,8CAA8C;EAC9C,iCAAiC;EACjC,2JAGkD;EAClD,uCAAuC;AATzB;AAWhB;EAAqB,wCAAwC;AAA1C;AACnB;EACE,UAAU;EACV,wBAAwB;EACxB,eAAe;AAHmB;AAKpC;EACE,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,qEAGkB;EAClB,oBAAoB;AARe;AAUrC;EACE;IAAkB,2BAA2B;EAA7B;AADsB;AAKxC;EAAU,kBAAkB;AAApB;AACR;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2GAG+B;EAC/B,4BAA4B;EAC5B,gEAAgE;EAChE,sBAAsB;AAVX;AAYb;EACE,gEAAgE;AAD1C;AAGxB;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,sBAAsB;EACtB,kbAMoD;EACpD,iEAAiE;AAbrD;AAed;EAAiC,kCAAkC;AAApC;AAC/B;EACE;IAAe,0BAA0B;IAAE,2BAA2B;EAAzD;AADyB;AAKxC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,qLAG8D;AATvD;AAWT;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,gKAGuD;AAP9B;AAS3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EAAE,YAAY;EACzB,aAAa;EAAE,mBAAmB;EAClC,SAAS;EAAE,uBAAuB;EAAE,eAAe;EACnD,gLAGsD;AAT1C;AAWd;EACE,mEAAmE;AADnD;AAGlB;EACE,UAAU;EACV,oDAAoD;EACpD,+BAA+B;EAC/B,oBAAoB;AAJmB;AAMzC;EACE,gEAAgE;AADrB;AAG7C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mEAAmE;EACnE,+BAA+B;EAC/B,oBAAoB;EACpB,gLAGsD;AAV1C;AAYd;EACE,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,oBAAoB;AAJmB;AAMzC;EACE;IAAyC,2BAA2B;EAA7B;AADD;AAKxC;EACE,aAAa;EACb,uBAAuB;EACvB,kEAAkE;AAHvD;AAKb;EACE,uBAAuB;EACvB,gEAAgE;AAF5B;AAItC;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mGAE4C;AAN3B;AAQnB;EACE,UAAU;EACV,eAAe;EACf,+FAE0C;AALA;AAO5C;EACE,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,wDAAwD;AAJ3C;AAMf;EAAsB,iCAAiC;AAAnC;AACpB;EACE,qBAAqB;AADiB;AAGxC;EACE;IACE,2BAA2B;EADoB;AADX;AAUxC;EACE,oCAAoC;EACpC,uBAAuB;EACvB,wCAAwC;EACxC,4CAA4C;EAC5C,iCAAiC;EACjC,gBAAgB;AANZ;AAQN;EACE,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAJvB;AAMR;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AALX;AAOP;EACE,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,6EAEiC;AANtB;AAWb;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;AAL7B;AAOnB;EACE,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAJQ;AAM1B;EACE,gCAAgC;AAD0B;AAG5D;EACE,gBAAgB;AAD8B;AAGhD;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AANc;AAWhC;EACE,mCAAmC;AADW;AAMhD;EACE;IAAO,UAAU;IAAE,0BAA0B;IAAE,iBAAiB;EAA3D;EACL;IAAO,UAAU;IAAE,wBAAwB;IAAI,eAAe;EAAzD;AAFmB;AAI1B;EACE,0EAA0E;AADnD;AAGzB;EACE;IAA2B,4BAA2B;EAA7B;AADa;ACp0CxC;EACE,qBAAsB;EACtB,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAAgE;AACjE;AACD;EACE,qBAAsB;EACtB,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAAgE;AACjE;AACD;EACE,qBAAsB;EACtB,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAAgE;AACjE;AACD;EACE,qBAAsB;EACtB,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAAgE;AACjE;AACD;EACE,+BAAgC;EAChC,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAA0E;AAC3E;AACD;EACE,+BAAgC;EAChC,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAA0E;AAC3E;AACD;EACE,+BAAgC;EAChC,gBAAiB;EACjB,kBAAmB;EACnB,kBAAmB;EACnB,4DAA0E;AAC3E;AAmBD;EACE;IACE,eAAgB;EACjB;EAED;IACE,6BAA8B;IAC9B,gBAAiB;IACjB,+BAAgC;EACjC;EAED;IACE,gBAAiB;EAClB;EAED;;;;;;IAME,gCAAiC;IACjC,gBAAiB;IACjB,uBAAwB;IACxB,+BAAgC;EACjC;AACF;AH2zBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AEx3B6H;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAAZ;EAAA,WAAY;EAAZ,eAAY;AAAA;AAgJnJ;EAAA,WAAQ;EAAR,eAAQ;EAAR,gBAAQ;AAAA;AF6Pf;EACE;IACE,yBAAyB;EADxB;AADW;AA2elB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MEx3B6H,qBAAY;MAAZ,0BAAY;MAAZ,4BAAY;MAAZ,6BAAY;MAAZ,8BAAY;MAgJnJ,wBAAQ;IFwuBE;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","/*!\n * @elixir-lu/ui — design tokens\n * Tailwind CSS v4 source. Two tiers:\n *   1. Palette tier  — raw UNI/LCSB brand values as plain custom properties.\n *                      NEVER reference these directly in app templates.\n *   2. Semantic tier — `@theme` block; this is what Tailwind generates\n *                      utilities from (bg-primary-900, text-danger-900, …).\n *                      Apps override the semantic→palette mapping in their own\n *                      CSS entry (e.g. DAISY remaps primary → LCSB).\n *\n * Consumption: this file must be processed by Tailwind, and the Tailwind\n * framework must be loaded FIRST in the same compilation (the consumer's CSS /\n * tailwindcss style block must begin with the tailwindcss import). With the\n * browser build (no build step) inline this file's contents into a\n * `<style type=\"text/tailwindcss\">` block, after that import. See README.\n * @font-face lives in `fonts.css` (plain CSS — load via <link>).\n */\n\n/* ───────────────────────────── Palette tier ───────────────────────────── */\n:root {\n  /* UNI Blue — foreground brand (headings, links, primary fills). 900 = UNI 100%. */\n  --color-uni-blue-50:  #e9ebed;\n  --color-uni-blue-100: #d2d6da;\n  --color-uni-blue-200: #bcc2c8;\n  --color-uni-blue-300: #a5aeb5;\n  --color-uni-blue-400: #8f9aa3;\n  --color-uni-blue-500: #788590;\n  --color-uni-blue-600: #62717e;\n  --color-uni-blue-700: #4b5d6b;\n  --color-uni-blue-800: #354859;\n  --color-uni-blue-900: #1e3446;\n  --color-uni-blue-950: #142f3f; /* dark surface (footer) */\n\n  /* UNI Red — attention: required fields, errors, logo dot. 900 = UNI 100%. */\n  --color-uni-red-50:  #fcecea;\n  --color-uni-red-100: #f9d8d5;\n  --color-uni-red-200: #f6c5c0;\n  --color-uni-red-300: #f3b1ab;\n  --color-uni-red-400: #f09e97;\n  --color-uni-red-500: #ed8a82;\n  --color-uni-red-600: #ea776d;\n  --color-uni-red-700: #e76358;\n  --color-uni-red-800: #e45043;\n  --color-uni-red-900: #e13c2e;\n  --color-uni-red-950: #e13c2e; /* same source value as 900 */\n\n  /* LCSB Sky — centre/entity colour, info surfaces. 900 = LCSB 100%. */\n  /* Source has 4 tints; intermediate steps repeat them (confirm w/ brand guide). */\n  --color-lcsb-sky-50:  #e7f5fc;\n  --color-lcsb-sky-100: #e7f5fc;\n  --color-lcsb-sky-200: #e7f5fc;\n  --color-lcsb-sky-300: #d7effb;\n  --color-lcsb-sky-400: #d7effb;\n  --color-lcsb-sky-500: #c7e8f9;\n  --color-lcsb-sky-600: #c7e8f9;\n  --color-lcsb-sky-700: #c7e8f9;\n  --color-lcsb-sky-800: #afdef6;\n  --color-lcsb-sky-900: #afdef6;\n  --color-lcsb-sky-950: #afdef6;\n\n}\n\n/* ───────────────────────────── Semantic tier ──────────────────────────── */\n/* Defaults below map the catalog identity (primary → UNI Blue). Apps may\n   override any --color-* / --font-* here in a later cascade layer.\n   `static` forces every token to be emitted as a CSS custom property even if no\n   utility references it — so overrides and JS can always rely on them. */\n@theme static {\n  /* Typography */\n  --font-sans:\n    \"Barlow\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --font-body:\n    \"Barlow\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --font-display: \"Barlow Condensed\", \"Arial Black\", Arial, sans-serif;\n  --font-mono:\n    ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  /* primary → UNI Blue */\n  --color-primary-50:  var(--color-uni-blue-50);\n  --color-primary-100: var(--color-uni-blue-100);\n  --color-primary-200: var(--color-uni-blue-200);\n  --color-primary-300: var(--color-uni-blue-300);\n  --color-primary-400: var(--color-uni-blue-400);\n  --color-primary-500: var(--color-uni-blue-500);\n  --color-primary-600: var(--color-uni-blue-600);\n  --color-primary-700: var(--color-uni-blue-700);\n  --color-primary-800: var(--color-uni-blue-800);\n  --color-primary-900: var(--color-uni-blue-900);\n  --color-primary-950: var(--color-uni-blue-950);\n\n  /* danger → UNI Red */\n  --color-danger-50:  var(--color-uni-red-50);\n  --color-danger-100: var(--color-uni-red-100);\n  --color-danger-200: var(--color-uni-red-200);\n  --color-danger-300: var(--color-uni-red-300);\n  --color-danger-400: var(--color-uni-red-400);\n  --color-danger-500: var(--color-uni-red-500);\n  --color-danger-600: var(--color-uni-red-600);\n  --color-danger-700: var(--color-uni-red-700);\n  --color-danger-800: var(--color-uni-red-800);\n  --color-danger-900: var(--color-uni-red-900);\n  --color-danger-950: var(--color-uni-red-950);\n\n  /* info → LCSB Sky */\n  --color-info-50:  var(--color-lcsb-sky-50);\n  --color-info-100: var(--color-lcsb-sky-100);\n  --color-info-200: var(--color-lcsb-sky-200);\n  --color-info-300: var(--color-lcsb-sky-300);\n  --color-info-400: var(--color-lcsb-sky-400);\n  --color-info-500: var(--color-lcsb-sky-500);\n  --color-info-600: var(--color-lcsb-sky-600);\n  --color-info-700: var(--color-lcsb-sky-700);\n  --color-info-800: var(--color-lcsb-sky-800);\n  --color-info-900: var(--color-lcsb-sky-900);\n  --color-info-950: var(--color-lcsb-sky-950);\n\n  /* text/icon colour to use on a primary-filled surface (WCAG: white on\n     primary-900 #1e3446 ≈ 12.3:1). Override per app when primary changes. */\n  --color-on-primary: #ffffff;\n}\n","/*!\n * @elixir-lu/ui — component classes\n * Tailwind CSS v4 `@layer components`. Uses ONLY semantic tokens/utilities\n * (primary / danger / info / on-primary + neutral gray), so an app can\n * restyle everything by remapping the semantic tier in tokens.css.\n *\n * Must be processed by Tailwind (it uses @apply, which needs the Tailwind\n * framework + tokens loaded first in the same compilation). Load the same way\n * as tokens.css, and always AFTER it. See README.\n *\n * Each class mirrors an existing data-catalog markup cluster (see\n * design-system-audit.md §6) 1:1, so adopting them is a visual no-op.\n */\n\n@layer components {\n  /* ── Buttons ────────────────────────────────────────────────────────── */\n  .btn-primary {\n    @apply inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors\n           bg-primary-900 text-on-primary\n           hover:bg-primary-800\n           focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-900 focus-visible:ring-offset-2;\n  }\n\n  .btn-secondary {\n    @apply inline-flex items-center justify-center gap-2 rounded-lg border border-primary-900 bg-white px-4 py-2 text-sm font-semibold transition-colors\n           text-primary-900\n           hover:bg-primary-900 hover:text-on-primary\n           focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-900 focus-visible:ring-offset-2;\n  }\n\n  /* Destructive action (delete/remove). The danger sibling of .btn-secondary —\n     outlined, fills on hover. Never use as the primary CTA. */\n  .btn-danger {\n    @apply inline-flex items-center justify-center gap-2 rounded-lg border border-danger-900 bg-white px-4 py-2 text-sm font-semibold transition-colors\n           text-danger-900\n           hover:bg-danger-900 hover:text-on-primary\n           focus:outline-none focus-visible:ring-2 focus-visible:ring-danger-900 focus-visible:ring-offset-2;\n  }\n\n  /* Pagination \"Previous/Next\" step button (+ disabled state). */\n  .btn-step {\n    @apply inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-3 py-1.5 font-display text-xs font-semibold uppercase tracking-[0.15em] transition-colors\n           text-primary-900\n           hover:border-primary-900 hover:bg-primary-900 hover:text-on-primary\n           focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-900;\n  }\n  .btn-step:disabled,\n  .btn-step[aria-disabled=\"true\"] {\n    @apply cursor-not-allowed border-gray-200 text-gray-400\n           hover:border-gray-200 hover:bg-white hover:text-gray-400;\n  }\n\n  /* Numbered pager item + current. */\n  .btn-page {\n    @apply inline-flex h-8 min-w-8 items-center justify-center rounded-lg border border-gray-300 bg-white px-2 font-display text-xs font-semibold tabular-nums transition-colors\n           text-primary-900\n           hover:border-primary-900 hover:bg-primary-900 hover:text-on-primary;\n  }\n  .btn-page-current {\n    @apply inline-flex h-8 min-w-8 items-center justify-center rounded-lg border border-primary-900 bg-primary-900 px-2 font-display text-xs font-semibold tabular-nums\n           text-on-primary;\n  }\n\n  /* Square icon buttons (search controls). */\n  .btn-icon {\n    @apply inline-flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 transition-colors\n           text-primary-900\n           hover:border-primary-900 hover:bg-gray-50;\n  }\n  .btn-icon-danger {\n    @apply inline-flex h-8 w-8 items-center justify-center rounded-lg border border-danger-200 bg-white transition-colors\n           text-danger-900\n           hover:border-danger-900 hover:bg-danger-900 hover:text-on-primary\n           focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-danger-900\n           disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400 disabled:hover:bg-white disabled:hover:text-gray-400;\n  }\n\n  /* ── Forms ──────────────────────────────────────────────────────────── */\n  .form-label {\n    @apply mb-1 block text-sm font-medium text-primary-900;\n  }\n  .form-label a {\n    @apply underline underline-offset-2 hover:text-primary-800;\n  }\n  /* Required-field marker: <span class=\"form-required\">*</span> */\n  .form-required {\n    @apply ml-0.5 text-danger-900;\n  }\n\n  .form-input {\n    @apply block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 shadow-sm\n           text-primary-900\n           focus:border-primary-900 focus:outline-none focus:ring-1 focus:ring-primary-900;\n  }\n  .form-input-error {\n    @apply border-danger-900 focus:border-danger-900 focus:ring-danger-900;\n  }\n  .form-textarea {\n    @apply block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 shadow-sm\n           text-primary-900\n           focus:border-primary-900 focus:outline-none focus:ring-1 focus:ring-primary-900;\n  }\n  .form-file {\n    @apply block w-full cursor-pointer rounded-lg border border-gray-300 bg-white p-2 text-sm text-gray-700 shadow-sm\n           file:mr-4 file:cursor-pointer file:border file:border-primary-900 file:bg-white file:px-4 file:py-2 file:text-sm file:font-semibold file:text-primary-900 file:transition-colors\n           hover:file:bg-primary-900 hover:file:text-on-primary\n           focus:border-primary-900 focus:outline-none focus:ring-1 focus:ring-primary-900;\n  }\n  .form-checkbox {\n    @apply h-4 w-4 rounded-md border-gray-300 text-primary-900 focus:ring-primary-900;\n  }\n  .form-help {\n    @apply mt-1 text-xs leading-relaxed text-gray-500;\n  }\n  .form-error {\n    @apply mt-1 text-sm text-danger-900;\n  }\n\n  /* ── Alerts / flashes ───────────────────────────────────────────────── */\n  .alert {\n    @apply relative mb-4 flex items-start gap-3 rounded-xl border px-4 py-3 text-primary-900;\n  }\n  .alert-error {\n    @apply border-danger-900 bg-danger-50;\n  }\n  .alert-info {\n    @apply border-primary-900 bg-primary-50;\n  }\n  /* Dismiss button placed at the end of an alert. */\n  .alert-close {\n    @apply text-primary-900 hover:text-primary-700;\n  }\n\n  /* ── Badges ─────────────────────────────────────────────────────────── */\n  .badge {\n    @apply inline-flex items-center rounded-md border border-gray-200 bg-white px-2 py-0.5 text-xs text-gray-700;\n  }\n  .badge-link {\n    @apply inline-flex items-center rounded-md border border-info-300 bg-info-50 px-2 py-0.5 text-xs transition-colors\n           text-primary-900\n           hover:border-primary-900 hover:bg-info-100;\n  }\n  /* Solid/filled badge for an emphasized tag (e.g. a primary role/status). Same\n     geometry as .badge, but a primary fill instead of a neutral outline. Use\n     sparingly — one emphasized tag per group; neutral tags stay on .badge. */\n  .badge-solid {\n    @apply inline-flex items-center rounded-md bg-primary-900 px-2 py-0.5 text-xs font-medium text-on-primary;\n  }\n  /* Static sky-tinted chip for people/entities (custodians, owners). Recedes\n     when many are shown; use instead of .badge-solid for names — solid stays\n     for status/count emphasis. */\n  .badge-tint {\n    @apply inline-flex items-center rounded-md border border-info-300 bg-info-50 px-2 py-0.5 text-xs text-primary-900;\n  }\n  /* Two-tone key/value pill (e.g. \"disease: Parkinson\"). Wrap the key in\n     .badge-split-key and the value in .badge-split-value. */\n  .badge-split {\n    @apply mr-1 mb-1 inline-flex overflow-hidden rounded-md border border-gray-200 text-xs;\n  }\n  .badge-split-key {\n    @apply bg-gray-100 px-2 py-0.5 font-medium text-gray-700;\n  }\n  .badge-split-value {\n    @apply bg-white px-2 py-0.5 text-primary-900;\n  }\n\n  /* ── Surfaces ───────────────────────────────────────────────────────── */\n  .card {\n    @apply rounded-2xl border border-gray-200 bg-white shadow-sm;\n  }\n\n  /* Collapsible section. Apply to a <details> element; .panel-summary on its\n     <summary>, .panel-title on the heading, .panel-icon on the chevron, and\n     .panel-body on the content wrapper. The chevron rotates when open. */\n  .panel {\n    @apply scroll-mt-8 py-5 lg:py-6;\n  }\n  .panel-summary {\n    @apply flex cursor-pointer list-none items-center justify-between gap-3;\n  }\n  .panel-summary::-webkit-details-marker {\n    display: none;\n  }\n  .panel-title {\n    @apply font-display text-xl font-semibold leading-tight tracking-tight text-primary-900 lg:text-2xl;\n  }\n  .panel-icon {\n    @apply h-4 w-4 text-gray-400 transition-transform;\n  }\n  details.panel[open] .panel-icon {\n    @apply rotate-180;\n  }\n  .panel-body {\n    @apply mt-4;\n  }\n\n  /* Definition-list block used on entity/detail pages. */\n  .data-list {\n    @apply divide-y divide-gray-100 border-y border-gray-200;\n  }\n  /* A single label/value row inside .data-list — label and value stack on\n     mobile, become a two-column grid from sm up. */\n  .data-row {\n    @apply grid grid-cols-1 gap-1 py-3 sm:gap-6;\n  }\n  @media (min-width: 40rem) {\n    .data-row {\n      grid-template-columns: 12rem minmax(0, 1fr);\n    }\n  }\n  .data-row dt,\n  .data-row-label {\n    @apply text-sm font-medium text-gray-500;\n  }\n  .data-row dd,\n  .data-row-value {\n    @apply text-sm leading-relaxed text-primary-900;\n  }\n\n  /* Long free-text field rendered as a quoted block. */\n  .field-quote {\n    @apply bg-gray-50 px-4 py-3 text-sm leading-relaxed text-primary-900 lg:text-base;\n  }\n  .field-quote a {\n    @apply text-primary-900 underline underline-offset-2 hover:text-primary-800;\n  }\n\n  /* Empty section: dashed border, one-line explanation, single CTA. Hide the\n     section header's own add button while its section is empty, so the CTA in\n     the box is the only add action on screen. */\n  .empty-state {\n    @apply rounded-md border border-dashed border-gray-300 px-6 py-8 text-center;\n  }\n  .empty-state-text {\n    @apply text-sm text-gray-500;\n  }\n\n  /* Bordered data table. */\n  .data-table {\n    @apply min-w-full border-collapse text-sm lg:text-base;\n  }\n  .data-table th,\n  .data-table td {\n    @apply border border-gray-200 px-3 py-2 align-top text-primary-900;\n  }\n  .data-table thead th,\n  .data-table .data-table-head {\n    @apply bg-gray-50 font-semibold;\n  }\n\n  /* ── Links ──────────────────────────────────────────────────────────── */\n  .link {\n    @apply text-primary-900 underline underline-offset-2 hover:text-primary-800;\n  }\n\n  /* ── Tabs / segmented control ───────────────────────────────────────── */\n  /* .tabs wraps the buttons; each tab is .tab, the active one .tab-active.\n     Muted gray bar, white raised active segment (shadcn/Radix pattern).\n     For detail-page section tabs use .tabs-underline / .tab-underline below;\n     for the animated versions use .t-tabs / .t-tabs--underline. */\n  .tabs {\n    @apply inline-flex items-center gap-1 rounded-xl bg-gray-100 p-1 font-body text-sm font-medium text-gray-600;\n  }\n  .tab {\n    @apply rounded-lg px-4 py-1.5 transition-colors hover:text-primary-900;\n  }\n  .tab-active {\n    @apply rounded-lg bg-white px-4 py-1.5 font-semibold text-primary-900 shadow-sm;\n  }\n\n  /* Underline tabs on a full-width rule (detail-page sections). State lives\n     in aria-selected — scripts only swap the attribute; hover previews with a\n     sky (info) underline, selected commits to primary. Static counterpart of\n     .t-tabs--underline. */\n  .tabs-underline {\n    @apply flex gap-6 overflow-x-auto border-b border-gray-300;\n  }\n  .tab-underline {\n    @apply -mb-px cursor-pointer shrink-0 border-b-2 border-transparent px-1 pb-3 text-sm font-medium text-gray-600\n           transition-colors hover:border-info-900 hover:text-primary-900 motion-reduce:transition-none;\n  }\n  .tab-underline[aria-selected=\"true\"] {\n    @apply border-primary-900 font-semibold text-primary-900;\n  }\n\n  /* ── Facets (filter sidebar) ────────────────────────────────────────── */\n  /* Group heading aligned to a fixed baseline so adjacent groups line up. */\n  .facet-heading {\n    @apply mb-4 flex h-9 items-end border-b border-gray-200 pb-2 text-xs font-medium leading-none text-gray-600;\n  }\n  .facet-list {\n    @apply space-y-0.5;\n  }\n  /* One clickable filter row; add .facet-selected when active. */\n  .facet {\n    @apply -mx-2 flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-primary-900 transition-colors hover:bg-gray-50;\n  }\n  .facet-selected {\n    @apply bg-info-50 hover:bg-info-100;\n  }\n  /* The checkbox indicator at the start of a row. */\n  .facet-check {\n    @apply flex h-4 w-4 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-white transition-colors;\n  }\n  .facet:hover .facet-check {\n    @apply border-primary-900;\n  }\n  .facet-selected .facet-check {\n    @apply border-primary-900 bg-primary-900;\n  }\n  .facet-label {\n    @apply min-w-0 flex-1 truncate;\n  }\n  .facet-count {\n    @apply shrink-0 text-xs tabular-nums text-gray-600;\n  }\n\n  /* ── Page header ────────────────────────────────────────────────────── */\n  .page-eyebrow {\n    @apply font-display text-sm font-semibold text-primary-900;\n  }\n  .page-title {\n    @apply font-display text-3xl font-medium tracking-tight text-primary-900 lg:text-5xl;\n  }\n  .page-lead {\n    @apply max-w-prose text-lg leading-snug text-primary-900 lg:text-xl;\n  }\n\n  /* ── Navigation bar ─────────────────────────────────────────────────── */\n  .navbar {\n    @apply border-b border-gray-200 bg-white;\n  }\n  /* Top-level nav item; use .nav-link-active for the current page. */\n  .nav-link {\n    @apply block rounded-lg px-3 py-2 text-sm font-medium text-primary-900 transition-colors hover:bg-gray-100;\n  }\n  .nav-link-active {\n    @apply block rounded-lg px-3 py-2 text-sm font-semibold text-primary-900 underline decoration-primary-900 decoration-2 underline-offset-8;\n  }\n\n  /* ── Footer ─────────────────────────────────────────────────────────── */\n  /* Dark bottom strip (logo · copyright · licence). */\n  .footer-bar {\n    @apply bg-primary-950 text-white/85;\n  }\n  /* A partner/brand logo tile in the footer logo grid. */\n  .partner-logo {\n    @apply flex h-20 w-full items-center justify-center rounded-xl border border-gray-200 px-4 py-3 opacity-80 transition hover:border-gray-300 hover:opacity-100;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n * Transitions (transitions-dev) — 21 portable CSS transitions.\n *\n * Motion-only: each t-* class owns its transition/animation and reads tuning\n * from the :root vars below. Bring your own sizing/colour with Tailwind\n * utilities in the markup (see styleguide.html). Every snippet keeps its\n * prefers-reduced-motion guard. Pasted verbatim from the skill; kept at top\n * level (not @layer components) so the @keyframes pass through the build.\n * ═══════════════════════════════════════════════════════════════════════════ */\n\n/* Install the tuning vars once (skill _root.css). */\n:root {\n  /* Motion tokens — shared scale */\n  --duration-stagger: 40ms;\n  --duration-micro: 80ms;\n  --duration-quick: 150ms;\n  --duration-fast: 250ms;\n  --duration-medium: 350ms;\n  --duration-slow: 400ms;\n  --duration-very-slow: 500ms;\n  --ease-smooth-out: cubic-bezier(0.22, 1, 0.36, 1);\n  --ease-in-out: ease-in-out;\n  --ease-out: ease-out;\n  --ease-linear: linear;\n  --ease-bounce: cubic-bezier(0.34, 1.36, 0.64, 1);\n  --ease-bounce-strong: cubic-bezier(0.34, 3.85, 0.64, 1);\n  --distance-micro: 4px;\n  --distance-small: 6px;\n  --distance-base: 8px;\n  --distance-medium: 12px;\n  --distance-large: 30px;\n  --scale-large: 0.96;\n  --scale-medium: 0.97;\n  --scale-small: 0.98;\n  --scale-tiny: 0.99;\n  --blur-small: 2px;\n  --blur-medium: 3px;\n  --blur-large: 8px;\n\n  /* Card resize */\n  --resize-dur: 300ms;\n  --resize-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Number pop-in */\n  --digit-dur: 500ms;\n  --digit-distance: 8px;\n  --digit-stagger: 70ms;\n  --digit-blur: 2px;\n  --digit-ease: cubic-bezier(0.34, 1.45, 0.64, 1);\n  --digit-dir-x: 0;\n  --digit-dir-y: 1;\n  /* Notification badge */\n  --badge-slide-dur: 260ms;\n  --badge-pop-dur: 500ms;\n  --badge-pop-close-dur: 180ms;\n  --badge-fade-dur: 400ms;\n  --badge-fade-close-dur: 180ms;\n  --badge-blur: 2px;\n  --badge-offset-x: -8.2px;\n  --badge-offset-y: 12.4px;\n  --badge-slide-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --badge-pop-ease: cubic-bezier(0.34, 1.36, 0.64, 1);\n  --badge-close-ease: cubic-bezier(0.4, 0, 0.2, 1);\n  /* Text states swap */\n  --text-swap-dur: 150ms;\n  --text-swap-translate-y: 4px;\n  --text-swap-blur: 2px;\n  --text-swap-ease: ease-in-out;\n  /* Menu dropdown */\n  --dropdown-open-dur: 250ms;\n  --dropdown-close-dur: 150ms;\n  --dropdown-pre-scale: 0.97;\n  --dropdown-closing-scale: 0.99;\n  --dropdown-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Modal open / close */\n  --modal-open-dur: 250ms;\n  --modal-close-dur: 150ms;\n  --modal-scale: 0.96;\n  --modal-scale-close: 0.96;\n  --modal-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Panel reveal */\n  --panel-open-dur: 400ms;\n  --panel-close-dur: 350ms;\n  --panel-translate-y: 100px;\n  --panel-blur: 2px;\n  --panel-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Page side-by-side */\n  --page-slide-dur: 250ms;\n  --page-fade-dur: 250ms;\n  --page-slide-distance: 8px;\n  --page-blur: 3px;\n  --page-stagger: 0ms;\n  --page-exit-enabled: 1;\n  --page-slide-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --page-fade-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Icon swap */\n  --icon-swap-dur: 250ms;\n  --icon-swap-blur: 2px;\n  --icon-swap-start-scale: 0.25;\n  --icon-swap-ease: ease-in-out;\n  /* Success check */\n  --check-opacity-dur: 500ms;\n  --check-rotate-dur: 500ms;\n  --check-rotate-from: 80deg;\n  --check-bob-dur: 500ms;\n  --check-y-amount: 40px;\n  --check-blur-dur: 500ms;\n  --check-blur-from: 10px;\n  --check-path-dur: 500ms;\n  --check-path-delay: 80ms;\n  --check-ease-out: cubic-bezier(0.22, 1, 0.36, 1);\n  --check-ease-opacity: cubic-bezier(0.22, 1, 0.36, 1);\n  --check-ease-rotate: cubic-bezier(0.22, 1, 0.36, 1);\n  --check-ease-bob: cubic-bezier(0.34, 1.35, 0.64, 1);\n  --check-ease-path: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Avatar group hover */\n  --avatar-lift: -4px;\n  --avatar-dur: 320ms;\n  --avatar-scale: 1.05;\n  --avatar-falloff: 0.45;\n  --avatar-ease-in: cubic-bezier(0.22, 1, 0.36, 1);\n  --avatar-ease-out: cubic-bezier(0.34, 3.85, 0.64, 1);\n  /* Error state shake */\n  --shake-distance: 6px;\n  --shake-overshoot: 4px;\n  --shake-dur-a: 80ms;\n  --shake-dur-b: 60ms;\n  --shake-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --revert-hold: 3000ms;\n  --revert-dur: 280ms;\n  /* Input clear with dissolve */\n  --clear-dur: 1000ms;\n  --clear-out-dur: 400ms;\n  --clear-in-dur: 400ms;\n  --clear-out-fly: 12px;\n  --clear-in-fly: 12px;\n  --clear-out-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --clear-in-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --clear-blur: 2px;\n  --glow-delay: 50ms;\n  --glow-peak-at: 0.15;\n  --glow-opacity: 0.42;\n  --glow-spread: 1.5;\n  /* Skeleton loader and reveal */\n  --pulse-dur: 1000ms;\n  --pulse-count: 1;\n  --pulse-min: 0.5;\n  --reveal-dur: 400ms;\n  --reveal-blur: 2px;\n  --reveal-ease: ease-in-out;\n  /* Shimmer text */\n  --shimmer-dur: 2000ms;\n  --shimmer-base: #7c7c7c;\n  --shimmer-highlight: #0d0d0d;\n  --shimmer-band: 400%;\n  --shimmer-ease: linear;\n  /* Tabs sliding */\n  --tabs-dur: 250ms;\n  --tabs-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --tabs-text-muted: rgba(15, 15, 15, 0.8);\n  --tabs-text-active: #0f0f0f;\n  --tabs-bar-bg: #f1f1f1;\n  --tabs-pill-bg: #ffffff;\n  /* Tooltip open/close */\n  --tt-in-dur: 150ms;\n  --tt-out-dur: 50ms;\n  --tt-scale: 0.98;\n  --tt-delay: 80ms;\n  --tt-in-ease: ease-out;\n  --tt-out-ease: ease-out;\n  --tt-bg: #ffffff;\n  --tt-fg: #2f2f2f;\n  /* Texts reveal */\n  --stagger-dur: 500ms;\n  --stagger-distance: 12px;\n  --stagger-stagger: 40ms;\n  --stagger-blur: 3px;\n  --stagger-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Card hover tilt */\n  --tilt-perspective: 1000px;\n  --tilt-return: 1000ms;\n  --tilt-return-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --tilt-follow: 400ms;\n  --tilt-follow-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --tilt-glare-opacity: 0.32;\n  --tilt-glare-fade: 300ms;\n  --tilt-glare-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  /* Plus to menu morph */\n  --morph-open-dur: 350ms;\n  --morph-close-dur: 250ms;\n  --morph-ease: cubic-bezier(0.34, 1.25, 0.64, 1);\n  --morph-close-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --morph-r-closed: 40px;\n  --morph-r-open: 20px;\n  --morph-fade-dur: 200ms;\n  --morph-slide: 40px;\n  --morph-rotate: 45deg;\n  --morph-scale: 0.97;\n  --morph-blur: 2px;\n  /* Accordion expand */\n  --acc-expand: 250ms;\n  --acc-collapse: 250ms;\n  --acc-chevron: 250ms;\n  --acc-ease: cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* 01 — Card resize */\n.t-resize {\n  transition:\n    width  var(--resize-dur) var(--resize-ease),\n    height var(--resize-dur) var(--resize-ease);\n  will-change: width, height;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-resize { transition: none !important; }\n}\n\n/* 02 — Number pop-in */\n@keyframes t-digit-pop-in {\n  0%   {\n    transform: translate(\n      calc(var(--digit-distance) * var(--digit-dir-x)),\n      calc(var(--digit-distance) * var(--digit-dir-y))\n    );\n    opacity: 0;\n    filter: blur(var(--digit-blur));\n  }\n  100% { transform: translate(0, 0); opacity: 1; filter: blur(0); }\n}\n.t-digit-group {\n  display: inline-flex;\n  align-items: baseline;\n}\n.t-digit {\n  display: inline-block;\n  will-change: transform, opacity, filter;\n}\n.t-digit-group.is-animating .t-digit {\n  animation: t-digit-pop-in var(--digit-dur) var(--digit-ease) both;\n}\n.t-digit-group.is-animating .t-digit[data-stagger=\"1\"] {\n  animation-delay: var(--digit-stagger);\n}\n.t-digit-group.is-animating .t-digit[data-stagger=\"2\"] {\n  animation-delay: calc(var(--digit-stagger) * 2);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-digit-group .t-digit { animation: none !important; }\n}\n\n/* 03 — Notification badge */\n@keyframes t-badge-slide-in {\n  from { transform: translate(var(--badge-offset-x), var(--badge-offset-y)); }\n  to   { transform: translate(0, 0); }\n}\n.t-badge {\n  position: absolute;\n  top: -6px;\n  right: -8px;\n  pointer-events: none;\n  will-change: transform;\n}\n.t-badge[data-open=\"true\"] {\n  animation: t-badge-slide-in var(--badge-slide-dur) var(--badge-slide-ease);\n}\n.t-badge-dot {\n  display: block;\n  transform-origin: center;\n  transform: scale(1);\n  opacity: 1;\n  filter: blur(0);\n  transition:\n    transform var(--badge-pop-dur)  var(--badge-pop-ease),\n    opacity   var(--badge-fade-dur) var(--badge-pop-ease),\n    filter    var(--badge-pop-dur)  var(--badge-pop-ease);\n  will-change: transform, opacity, filter;\n}\n.t-badge[data-open=\"false\"] .t-badge-dot {\n  transform: scale(0);\n  opacity: 0;\n  filter: blur(var(--badge-blur));\n  transition:\n    transform var(--badge-pop-close-dur)  var(--badge-close-ease),\n    opacity   var(--badge-fade-close-dur) var(--badge-close-ease),\n    filter    var(--badge-pop-close-dur)  var(--badge-close-ease);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-badge, .t-badge-dot { animation: none !important; transition: none !important; }\n}\n\n/* 04 — Text states swap */\n.t-text-swap {\n  display: inline-block;\n  transform: translateY(0);\n  filter: blur(0);\n  opacity: 1;\n  transition:\n    transform var(--text-swap-dur) var(--text-swap-ease),\n    filter    var(--text-swap-dur) var(--text-swap-ease),\n    opacity   var(--text-swap-dur) var(--text-swap-ease);\n  will-change: transform, filter, opacity;\n}\n.t-text-swap.is-exit {\n  transform: translateY(calc(var(--text-swap-translate-y) * -1));\n  filter: blur(var(--text-swap-blur));\n  opacity: 0;\n}\n.t-text-swap.is-enter-start {\n  transform: translateY(var(--text-swap-translate-y));\n  filter: blur(var(--text-swap-blur));\n  opacity: 0;\n  transition: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-text-swap { transition: none !important; }\n}\n\n/* 05 — Menu dropdown */\n.t-dropdown {\n  transform-origin: top left;\n  transform: scale(var(--dropdown-pre-scale));\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    transform var(--dropdown-open-dur) var(--dropdown-ease),\n    opacity   var(--dropdown-open-dur) var(--dropdown-ease);\n  will-change: transform, opacity;\n}\n.t-dropdown[data-origin=\"top-right\"]     { transform-origin: top right; }\n.t-dropdown[data-origin=\"top-center\"]    { transform-origin: top center; }\n.t-dropdown[data-origin=\"bottom-left\"]   { transform-origin: bottom left; }\n.t-dropdown[data-origin=\"bottom-center\"] { transform-origin: bottom center; }\n.t-dropdown[data-origin=\"bottom-right\"]  { transform-origin: bottom right; }\n.t-dropdown.is-open {\n  transform: scale(1);\n  opacity: 1;\n  pointer-events: auto;\n}\n.t-dropdown.is-closing {\n  transform: scale(var(--dropdown-closing-scale));\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    transform var(--dropdown-close-dur) var(--dropdown-ease),\n    opacity   var(--dropdown-close-dur) var(--dropdown-ease);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-dropdown { transition: none !important; }\n}\n\n/* 06 — Modal open / close */\n.t-modal {\n  transform-origin: center;\n  transform: scale(var(--modal-scale));\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    transform var(--modal-open-dur) var(--modal-ease),\n    opacity   var(--modal-open-dur) var(--modal-ease);\n  will-change: transform, opacity;\n}\n.t-modal.is-open {\n  transform: scale(1);\n  opacity: 1;\n  pointer-events: auto;\n}\n.t-modal.is-closing {\n  transform: scale(var(--modal-scale-close));\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    transform var(--modal-close-dur) var(--modal-ease),\n    opacity   var(--modal-close-dur) var(--modal-ease);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-modal { transition: none !important; }\n}\n\n/* 07 — Panel reveal */\n.t-panel-slide {\n  transform: translateY(var(--panel-translate-y));\n  opacity: 0;\n  filter: blur(var(--panel-blur));\n  pointer-events: none;\n  transition:\n    transform var(--panel-close-dur) var(--panel-ease),\n    opacity   var(--panel-close-dur) var(--panel-ease),\n    filter    var(--panel-close-dur) var(--panel-ease);\n  will-change: transform, opacity, filter;\n}\n.t-panel-slide[data-open=\"true\"] {\n  transform: translateY(0);\n  opacity: 1;\n  filter: blur(0);\n  pointer-events: auto;\n  transition:\n    transform var(--panel-open-dur) var(--panel-ease),\n    opacity   var(--panel-open-dur) var(--panel-ease),\n    filter    var(--panel-open-dur) var(--panel-ease);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-panel-slide { transition: none !important; }\n}\n\n/* 08 — Page side-by-side */\n.t-page-slide {\n  position: relative;\n}\n.t-page-slide .t-page[data-page-id=\"1\"] {\n  --t-page-from-x: calc(var(--page-slide-distance) * -1);\n}\n.t-page-slide .t-page[data-page-id=\"2\"] {\n  --t-page-from-x: var(--page-slide-distance);\n}\n.t-page-slide .t-page {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateX(calc(var(--t-page-from-x, 0px) * var(--page-exit-enabled)));\n  filter: blur(calc(var(--page-blur) * var(--page-exit-enabled)));\n  transition:\n    opacity   var(--page-fade-dur)  var(--page-fade-ease),\n    transform var(--page-slide-dur) var(--page-slide-ease),\n    filter    var(--page-slide-dur) var(--page-slide-ease);\n  will-change: opacity, transform, filter;\n}\n.t-page-slide[data-page=\"1\"] .t-page[data-page-id=\"1\"],\n.t-page-slide[data-page=\"2\"] .t-page[data-page-id=\"2\"] {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateX(0);\n  filter: blur(0);\n  transition-delay: var(--page-stagger);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-page-slide .t-page { transition: none !important; }\n}\n\n/* 09 — Icon swap */\n.t-icon-swap {\n  position: relative;\n  display: inline-grid;\n}\n.t-icon-swap .t-icon {\n  grid-area: 1 / 1;\n  transition:\n    opacity   var(--icon-swap-dur) var(--icon-swap-ease),\n    filter    var(--icon-swap-dur) var(--icon-swap-ease),\n    transform var(--icon-swap-dur) var(--icon-swap-ease);\n  will-change: opacity, filter, transform;\n}\n.t-icon-swap[data-state=\"a\"] .t-icon[data-icon=\"a\"],\n.t-icon-swap[data-state=\"b\"] .t-icon[data-icon=\"b\"] {\n  opacity: 1;\n  filter: blur(0);\n  transform: scale(1);\n}\n.t-icon-swap[data-state=\"a\"] .t-icon[data-icon=\"b\"],\n.t-icon-swap[data-state=\"b\"] .t-icon[data-icon=\"a\"] {\n  opacity: 0;\n  filter: blur(var(--icon-swap-blur));\n  transform: scale(var(--icon-swap-start-scale));\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-icon-swap .t-icon { transition: none !important; }\n}\n\n/* 10 — Success check */\n.t-success-check {\n  display: inline-block;\n  transform-origin: center;\n  opacity: 0;\n  will-change: transform, opacity, filter;\n}\n.t-success-check svg { display: block; overflow: visible; }\n.t-success-check svg path {\n  stroke-dasharray: 20;\n  stroke-dashoffset: 20;\n}\n.t-success-check[data-state=\"in\"] {\n  animation:\n    t-check-fade   var(--check-opacity-dur) var(--check-ease-opacity) forwards,\n    t-check-rotate var(--check-rotate-dur)  var(--check-ease-rotate)  forwards,\n    t-check-blur   var(--check-blur-dur)    var(--check-ease-out)     forwards,\n    t-check-bob    var(--check-bob-dur)     var(--check-ease-bob)     forwards;\n}\n.t-success-check[data-state=\"in\"] svg path {\n  animation: t-check-draw var(--check-path-dur) var(--check-ease-path) var(--check-path-delay, 0ms) forwards;\n}\n@keyframes t-check-fade { from { opacity: 0; } to { opacity: 1; } }\n@keyframes t-check-rotate {\n  from { transform: rotate(var(--check-rotate-from)); }\n  to   { transform: rotate(0deg); }\n}\n@keyframes t-check-blur {\n  from { filter: blur(var(--check-blur-from)); }\n  to   { filter: blur(0); }\n}\n@keyframes t-check-bob {\n  from { translate: 0 var(--check-y-amount); }\n  to   { translate: 0 0; }\n}\n@keyframes t-check-draw { to { stroke-dashoffset: 0; } }\n@media (prefers-reduced-motion: reduce) {\n  .t-success-check { animation: none !important; opacity: 1; }\n  .t-success-check svg path { animation: none !important; stroke-dashoffset: 0 !important; }\n}\n\n/* 11 — Avatar group hover */\n.t-avatar {\n  transform-origin: center;\n  transform:\n    translateY(var(--shift, 0px))\n    scale(var(--scale-active, 1));\n  transition: transform var(--avatar-dur) var(--avatar-ease-in);\n  will-change: transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-avatar { transition: none !important; transform: none !important; }\n}\n\n/* 12 — Error state shake */\n.t-input {\n  transition: border-color 150ms ease-out;\n  will-change: transform;\n}\n.t-input.is-error {\n  transition: border-color var(--revert-dur, 280ms) ease-out;\n}\n.t-error-msg {\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity    var(--revert-dur, 280ms) ease-out,\n    visibility 0s linear var(--revert-dur, 280ms);\n}\n.t-input-wrap.is-error .t-error-msg {\n  opacity: 1;\n  visibility: visible;\n  transition:\n    opacity    var(--revert-dur, 280ms) ease-out,\n    visibility 0s linear 0s;\n}\n.t-input.is-shaking {\n  animation: t-input-shake calc(\n      var(--shake-dur-a) * 2 + var(--shake-dur-b) * 2\n    ) linear;\n}\n@keyframes t-input-shake {\n  0%      { transform: translateX(0);                                 animation-timing-function: var(--shake-ease); }\n  28.57%  { transform: translateX(var(--shake-distance));             animation-timing-function: var(--shake-ease); }\n  57.14%  { transform: translateX(calc(var(--shake-distance) * -1)); animation-timing-function: var(--shake-ease); }\n  78.57%  { transform: translateX(var(--shake-overshoot));            animation-timing-function: var(--shake-ease); }\n  100%    { transform: translateX(0); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-input { animation: none !important; transform: none !important; }\n}\n\n/* 13 — Input clear with dissolve */\n.t-clear {\n  position: relative;\n  overflow: hidden;\n}\n.t-clear-mirror,\n.t-clear-placeholder {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  white-space: nowrap;\n  overflow: hidden;\n  z-index: 2;\n}\n.t-clear-mirror { opacity: 0; }\n.t-clear.has-value .t-clear-mirror,\n.t-clear.is-clearing .t-clear-mirror { opacity: 1; }\n.t-clear.has-value > input,\n.t-clear.is-clearing > input {\n  -webkit-text-fill-color: transparent;\n}\n.t-clear.has-value .t-clear-placeholder { opacity: 0; }\n.t-clear-glow {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: 3;\n  mix-blend-mode: multiply;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-clear-glow { opacity: 0 !important; }\n}\n\n/* 14 — Skeleton loader and reveal */\n.t-skel { position: relative; }\n.t-skel-skeleton,\n.t-skel-content {\n  position: absolute;\n  inset: 0;\n}\n.t-skel-skeleton {\n  z-index: 1;\n  opacity: 1;\n  filter: blur(0);\n  transition:\n    opacity var(--reveal-dur) var(--reveal-ease),\n    filter  var(--reveal-dur) var(--reveal-ease);\n}\n.t-skel-content {\n  z-index: 2;\n  opacity: 0;\n  filter: blur(var(--reveal-blur));\n  transition:\n    opacity var(--reveal-dur) var(--reveal-ease),\n    filter  var(--reveal-dur) var(--reveal-ease);\n}\n.t-skel.is-revealed .t-skel-skeleton {\n  opacity: 0;\n  filter: blur(var(--reveal-blur));\n}\n.t-skel.is-revealed .t-skel-content {\n  opacity: 1;\n  filter: blur(0);\n}\n.t-skel.is-resetting .t-skel-skeleton,\n.t-skel.is-resetting .t-skel-content {\n  transition: none !important;\n}\n.t-skel-skeleton.is-pulsing > * {\n  animation: t-skel-pulse var(--pulse-dur) ease-in-out var(--pulse-count);\n}\n@keyframes t-skel-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: var(--pulse-min); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-skel-skeleton, .t-skel-content {\n    transition: none !important;\n  }\n  .t-skel-skeleton.is-pulsing > * { animation: none !important; }\n}\n\n/* 15 — Shimmer text */\n.t-shimmer {\n  position: relative;\n  display: inline-block;\n  color: var(--shimmer-base);\n}\n.t-shimmer::before {\n  content: attr(data-text);\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background-image: linear-gradient(\n    90deg,\n    transparent          0%,\n    transparent         40%,\n    var(--shimmer-highlight) 50%,\n    transparent         60%,\n    transparent        100%\n  );\n  background-size: var(--shimmer-band) 100%;\n  background-repeat: no-repeat;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  -webkit-text-fill-color: transparent;\n  animation: t-shimmer var(--shimmer-dur) var(--shimmer-ease) infinite;\n}\n@keyframes t-shimmer {\n  0%   { background-position: 100% 0; }\n  100% { background-position: 0% 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-shimmer::before { animation: none !important; }\n}\n\n/* 16 — Tabs sliding */\n.t-tabs {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 3px;\n  border-radius: 48px;\n  background: var(--tabs-bar-bg);\n}\n.t-tab {\n  position: relative;\n  appearance: none;\n  border: 0;\n  background: transparent;\n  height: 30px;\n  padding: 4px 12px;\n  color: var(--tabs-text-muted);\n  cursor: pointer;\n  border-radius: 48px;\n  z-index: 1;\n  transition: color var(--tabs-dur) var(--tabs-ease);\n}\n.t-tab:not([aria-selected=\"true\"]):hover,\n.t-tab[aria-selected=\"true\"] {\n  color: var(--tabs-text-active);\n}\n.t-tabs-pill {\n  position: absolute;\n  top: 3px;\n  left: 0;\n  height: 30px;\n  width: 0;\n  background: var(--tabs-pill-bg);\n  border-radius: 48px;\n  transform: translateX(0);\n  transition:\n    transform var(--tabs-dur) var(--tabs-ease),\n    width     var(--tabs-dur) var(--tabs-ease);\n  will-change: transform, width;\n  z-index: 0;\n  pointer-events: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-tabs-pill, .t-tab { transition: none !important; }\n}\n\n/* 17 — Tooltip open/close */\n.t-tt-wrap {\n  position: relative;\n  display: inline-block;\n}\n.t-tt {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translate(-50%, 0) scale(var(--tt-scale));\n  transform-origin: 50% 100%;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: var(--tt-bg);\n  color: var(--tt-fg);\n  white-space: nowrap;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.06),\n    0 2px 6px 0 rgba(0, 0, 0, 0.05),\n    0 4px 42px 0 rgba(0, 0, 0, 0.06);\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    opacity   var(--tt-out-dur) var(--tt-out-ease),\n    transform var(--tt-out-dur) var(--tt-out-ease);\n}\n.t-tt-wrap:hover .t-tt,\n.t-tt-trigger:focus-visible + .t-tt {\n  opacity: 1;\n  transform: translate(-50%, 0) scale(1);\n  transition-duration: var(--tt-in-dur);\n  transition-timing-function: var(--tt-in-ease);\n  transition-delay: var(--tt-delay);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-tt { transition: none !important; }\n}\n\n/* 18 — Texts reveal */\n.t-stagger-line {\n  display: block;\n  opacity: 0;\n  transform: translateY(var(--stagger-distance));\n  filter: blur(var(--stagger-blur));\n  transition:\n    opacity   var(--stagger-dur) var(--stagger-ease),\n    transform var(--stagger-dur) var(--stagger-ease),\n    filter    var(--stagger-dur) var(--stagger-ease);\n  will-change: transform, opacity, filter;\n}\n.t-stagger-line--2 { transition-delay: var(--stagger-stagger); }\n.t-stagger.is-shown .t-stagger-line {\n  opacity: 1;\n  transform: translateY(0);\n  filter: blur(0);\n}\n.t-stagger.is-hiding .t-stagger-line {\n  opacity: 0;\n  transform: translateY(0);\n  filter: blur(0);\n  transition:\n    opacity 200ms ease,\n    transform 0s linear,\n    filter 0s linear;\n  transition-delay: 0s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-stagger-line { transition: none !important; }\n}\n\n/* 19 — Card hover tilt */\n.t-tilt { touch-action: none; }\n.t-tilt-card {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  transform:\n    perspective(var(--tilt-perspective))\n    rotateX(var(--tilt-rx, 0deg))\n    rotateY(var(--tilt-ry, 0deg));\n  transform-style: preserve-3d;\n  transition: transform var(--tilt-return) var(--tilt-return-ease);\n  will-change: transform;\n}\n.t-tilt-card.is-tilting {\n  transition: transform var(--tilt-follow) var(--tilt-follow-ease);\n}\n.t-tilt-glare {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0;\n  mix-blend-mode: screen;\n  background:\n    radial-gradient(circle 95px at var(--tilt-gx, 50%) var(--tilt-gy, 50%),\n      rgba(255,255,255,0.48), rgba(255,255,255,0.06) 52%, rgba(255,255,255,0) 84%),\n    radial-gradient(circle 200px at var(--tilt-gx, 50%) var(--tilt-gy, 50%),\n      rgba(255,255,255,0.22), rgba(255,255,255,0.04) 58%, rgba(255,255,255,0) 78%),\n    radial-gradient(circle 360px at var(--tilt-gx, 50%) var(--tilt-gy, 50%),\n      rgba(255,255,255,0.10), rgba(255,255,255,0) 88%);\n  transition: opacity var(--tilt-glare-fade) var(--tilt-glare-ease);\n}\n.t-tilt.is-hover .t-tilt-glare { opacity: var(--tilt-glare-opacity); }\n@media (prefers-reduced-motion: reduce) {\n  .t-tilt-card { transform: none !important; transition: none !important; }\n}\n\n/* 20 — Plus to menu morph */\n.t-morph {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--morph-r-closed);\n  overflow: hidden;\n  transition:\n    width var(--morph-close-dur) var(--morph-close-ease),\n    height var(--morph-close-dur) var(--morph-close-ease),\n    border-radius var(--morph-close-dur) var(--morph-close-ease);\n}\n.t-morph[data-open=\"true\"] {\n  width: 183px;\n  height: 172px;\n  border-radius: var(--morph-r-open);\n  transition:\n    width var(--morph-open-dur) var(--morph-ease),\n    height var(--morph-open-dur) var(--morph-ease),\n    border-radius var(--morph-open-dur) var(--morph-ease);\n}\n.t-morph-plus {\n  position: absolute;\n  inset: auto 0 0 auto;\n  width: 40px; height: 40px;\n  display: grid; place-items: center;\n  border: 0; background: transparent; cursor: pointer;\n  transition:\n    opacity var(--morph-fade-dur) var(--morph-close-ease),\n    transform var(--morph-open-dur) var(--morph-close-ease),\n    filter var(--morph-fade-dur) var(--morph-close-ease);\n}\n.t-morph-plus svg {\n  transition: transform var(--morph-open-dur) var(--morph-close-ease);\n}\n.t-morph[data-open=\"true\"] .t-morph-plus {\n  opacity: 0;\n  transform: translateX(calc(-1 * var(--morph-slide)));\n  filter: blur(var(--morph-blur));\n  pointer-events: none;\n}\n.t-morph[data-open=\"true\"] .t-morph-plus svg {\n  transform: scale(var(--morph-scale)) rotate(var(--morph-rotate));\n}\n.t-morph-menu {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transform: translateX(var(--morph-slide)) scale(var(--morph-scale));\n  filter: blur(var(--morph-blur));\n  pointer-events: none;\n  transition:\n    opacity var(--morph-fade-dur) var(--morph-close-ease),\n    transform var(--morph-open-dur) var(--morph-close-ease),\n    filter var(--morph-fade-dur) var(--morph-close-ease);\n}\n.t-morph[data-open=\"true\"] .t-morph-menu {\n  opacity: 1;\n  transform: translateX(0) scale(1);\n  filter: blur(0);\n  pointer-events: auto;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-morph, .t-morph-plus, .t-morph-menu { transition: none !important; }\n}\n\n/* 21 — Accordion expand */\n.t-acc-panel {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows var(--acc-collapse) var(--acc-ease);\n}\n.t-acc[data-open=\"true\"] .t-acc-panel {\n  grid-template-rows: 1fr;\n  transition: grid-template-rows var(--acc-expand) var(--acc-ease);\n}\n.t-acc-panel-inner {\n  overflow: hidden;\n  opacity: 0;\n  filter: blur(2px);\n  transition:\n    opacity var(--acc-collapse) var(--acc-ease),\n    filter var(--acc-collapse) var(--acc-ease);\n}\n.t-acc[data-open=\"true\"] .t-acc-panel-inner {\n  opacity: 1;\n  filter: blur(0);\n  transition:\n    opacity var(--acc-expand) var(--acc-ease),\n    filter var(--acc-expand) var(--acc-ease);\n}\n.t-acc-chevron {\n  display: inline-flex;\n  transform: scaleY(1);\n  transform-origin: center;\n  transition: transform var(--acc-chevron) var(--acc-ease);\n}\n.t-acc-chevron path { vector-effect: non-scaling-stroke; }\n.t-acc[data-open=\"true\"] .t-acc-chevron {\n  transform: scaleY(-1);\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-acc-panel, .t-acc-panel-inner, .t-acc-chevron {\n    transition: none !important;\n  }\n}\n\n/* ── Theme overrides — align transitions-dev surfaces with @elixir-lu/ui ──\n   The t-* snippets ship neutral demo styling; these overrides re-skin them\n   with the semantic tokens so they sit naturally in the design system.\n   Motion (durations/easings) is untouched. */\n:root {\n  --tabs-bar-bg: var(--color-gray-100);\n  --tabs-pill-bg: #ffffff;\n  --tabs-text-muted: var(--color-gray-600);\n  --tabs-text-active: var(--color-primary-900);\n  --tt-bg: var(--color-primary-950);\n  --tt-fg: #ffffff;\n}\n.t-tabs {\n  gap: 4px;\n  padding: 4px;\n  border-radius: 12px;\n  font-family: var(--font-body);\n}\n.t-tab {\n  height: 36px;\n  padding: 6px 16px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n.t-tabs-pill {\n  top: 4px;\n  height: 36px;\n  border-radius: 8px;\n  box-shadow:\n    0 1px 2px rgba(16, 24, 40, 0.08),\n    0 1px 3px rgba(16, 24, 40, 0.1);\n}\n\n/* Underline tabs — same t-tabs mechanics (the pill becomes the sliding\n   indicator bar), classic docs-style look. Add .t-tabs--underline to .t-tabs. */\n.t-tabs--underline {\n  gap: 0.25rem;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  border-bottom: 1px solid var(--color-gray-200);\n}\n.t-tabs--underline .t-tab {\n  height: 42px;\n  padding: 8px 14px;\n  border-radius: 8px 8px 0 0;\n  font-weight: 500;\n}\n.t-tabs--underline .t-tab:not([aria-selected=\"true\"]):hover {\n  background: var(--color-gray-50);\n}\n.t-tabs--underline .t-tab[aria-selected=\"true\"] {\n  font-weight: 600;\n}\n.t-tabs--underline .t-tabs-pill {\n  top: auto;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 999px;\n  background: var(--color-primary-900);\n  box-shadow: none;\n}\n\n/* Underline tabs: stronger active highlight — soft primary tint behind the\n   active label, rounded to the top so it reads as connected to the panel. */\n.t-tabs--underline .t-tab[aria-selected=\"true\"] {\n  background: var(--color-primary-50);\n}\n\n/* Tab panel enter: small rise + fade + un-blur when a tab reveals its panel.\n   Add .is-entering to the shown panel (remove -> reflow -> add to replay). */\n@keyframes t-tab-panel-in {\n  from { opacity: 0; transform: translateY(6px); filter: blur(2px); }\n  to   { opacity: 1; transform: translateY(0);   filter: blur(0); }\n}\n.t-tab-panel.is-entering {\n  animation: t-tab-panel-in var(--duration-fast) var(--ease-smooth-out) both;\n}\n@media (prefers-reduced-motion: reduce) {\n  .t-tab-panel.is-entering { animation: none \\!important; }\n}\n","/*\n * dawid-front — CSS entry point.\n *\n * Import order is mandated by @elixir-lu/ui (see elixir-lu-ui/PROVENANCE.md):\n *   1. the Tailwind framework\n *   2. tokens.css      — defines the semantic tier (@theme)\n *   3. components.css  — consumes the semantic tier via @apply\n *   4. this file's own overrides, last\n *\n * dawid-front does NOT remap the semantic tier: the app's identity already is\n * the design-system default (primary → UNI Blue, danger → UNI Red).\n */\n@import \"tailwindcss\";\n@import \"./elixir-lu-ui/tokens.css\";\n@import \"./elixir-lu-ui/components.css\";\n\n/* ── Fonts ───────────────────────────────────────────────────────────────\n * Same Barlow / Barlow Condensed woff2 files the design system ships, but\n * declared here so webpack rewrites the URLs — upstream `fonts.css` uses paths\n * relative to itself, which our asset pipeline would not resolve.\n * Family names must stay in sync with --font-sans/--font-display in tokens.css.\n */\n@font-face {\n  font-family: \"Barlow\";\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-400.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Barlow\";\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-500.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Barlow\";\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-600.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Barlow\";\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-700.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Barlow Condensed\";\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-condensed-400.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Barlow Condensed\";\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-condensed-500.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"Barlow Condensed\";\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n  src: url(\"../../assets/fonts/barlow-condensed-600.woff2\") format(\"woff2\");\n}\n\n/* ── App-specific tokens ─────────────────────────────────────────────────\n * Only what the design system does not cover. Everything else (colour,\n * typography, radii, card elevation) comes from the semantic tier — do not\n * reintroduce local colour tokens here.\n */\n@theme {\n  /* Overlay elevation. The design system styles flat surfaces (`.card` is\n     `shadow-sm`) but has no floating-layer scale, and dawid is overlay-heavy:\n     dropdowns, comboboxes, date pickers, dialogs. */\n  --shadow-dropdown: 0 4px 20px rgba(30, 52, 70, 0.15);\n  --shadow-overlay: 0 12px 40px rgba(30, 52, 70, 0.22);\n}\n\n/* ── Base ────────────────────────────────────────────────────────────────\n * The design system ships tokens and component classes, not a reset — it\n * assumes a document that already sets its body font and heading treatment.\n */\n@layer base {\n  html {\n    font-size: 16px;\n  }\n\n  body {\n    font-family: var(--font-body);\n    line-height: 1.6;\n    color: var(--color-primary-900);\n  }\n\n  p {\n    line-height: 1.6;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: var(--font-display);\n    font-weight: 600;\n    letter-spacing: -0.01em;\n    color: var(--color-primary-900);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
